<!-- PROFILE TYPE  -->

<p><strong>TIPO DI PROFILO</strong></p>

<!-- <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-1 fusion-one-half fusion-column-first 1_2"
    style="
      margin-top: 0px;
      margin-bottom: 0px;
      width: 50%;
      width: calc(50% - ((4%) * 0.5));
      margin-right: 4%;
    "
  >
    <div
      class="fusion-column-wrapper fusion-column-wrapper-1"
      style="
        padding: 0px;
        background-position: left top;
        background-repeat: no-repeat;
        background-size: cover;
        height: auto;
      "
      data-bg-url=""
    >
      <label class="control control-radio">
        <p class="fusion-text">Impresa</p>
        <input
          name="profile-type"
          type="radio"
          [(ngModel)]="showhidedesigner"
          [value]="false"
          (click)="deleteSpecializations(); switchUserType()"
        />
        <div class="control_indicator"></div>
      </label>
    </div>
  </div>
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-2 fusion-one-half fusion-column-last 1_2"
    style="
      margin-top: 0px;
      margin-bottom: 0px;
      width: 50%;
      width: calc(50% - ((4%) * 0.5));
    "
  >
    <div
      class="fusion-column-wrapper fusion-column-wrapper-2"
      style="
        padding: 0px;
        background-position: left top;
        background-repeat: no-repeat;
        background-size: cover;
        height: auto;
      "
      data-bg-url=""
    >
      <label class="control control-radio">
        <p class="fusion-text">Progettista</p>
        <input
          name="profile-type"
          type="radio"
          [(ngModel)]="showhidedesigner"
          [value]="true"
          (click)="deleteSpecializations(); switchUserType()"
        />
        <div class="control_indicator"></div>
      </label>
    </div>
  </div>
</div> -->

<div class="fusion-builder-row fusion-builder-row-inner fusion-row">
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-1 fusion-one-third fusion-column-first 1_3"
    style="
      margin-top: 0px;
      margin-bottom: 0px;
      width: 33.33%;
      width: calc(33.33% - ((4% + 4%) * 0.3333));
      margin-right: 4%;
    "
  >
    <div
      class="fusion-column-wrapper fusion-column-wrapper-1"
      style="
        padding: 0px;
        background-position: left top;
        background-repeat: no-repeat;
        background-size: cover;
        height: auto;
      "
      data-bg-url=""
    >
      <label class="control control-radio">
        <p class="fusion-text">Impresa</p>
        <input
          name="profile-type"
          type="radio"
          [(ngModel)]="showhidedesigner"
          [value]="false"
          (click)="deleteSpecializations(); switchUserType()"
        />
        <div class="control_indicator"></div>
      </label>
    </div>
  </div>
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-2 fusion-one-third 1_3"
    style="
      margin-top: 0px;
      margin-bottom: 0px;
      width: 33.33%;
      width: calc(33.33% - ((4% + 4%) * 0.3333));
      margin-right: 4%;
    "
  >
    <div
      class="fusion-column-wrapper fusion-column-wrapper-2"
      style="
        padding: 0px;
        background-position: left top;
        background-repeat: no-repeat;
        background-size: cover;
        height: auto;
      "
      data-bg-url=""
    >
      <label class="control control-radio">
        <p class="fusion-text">Progettista</p>
        <input
          name="profile-type"
          type="radio"
          [(ngModel)]="showhidedesigner"
          [value]="true"
          (click)="deleteSpecializations(); switchUserType()"
        />
        <div class="control_indicator"></div>
      </label>
    </div>
  </div>
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-3 fusion-one-third fusion-column-last 1_3"
    style="
      margin-top: 0px;
      margin-bottom: 0px;
      width: 33.33%;
      width: calc(33.33% - ((4% + 4%) * 0.3333));
    "
  >
    <div
      class="fusion-column-wrapper fusion-column-wrapper-3"
      style="
        padding: 0px;
        background-position: left top;
        background-repeat: no-repeat;
        background-size: cover;
        height: auto;
      "
      data-bg-url=""
    >
      <label class="control control-radio">
        <p class="fusion-text">Committente</p>
        <input
          name="private-registry"
          type="radio"
          [(ngModel)]="privateRegistry"
          [value]="true"
          (click)="changeToPrivateRegistry()"
        />
        <div class="control_indicator"></div>
      </label>
    </div>
  </div>
</div>

<div class="fusion-sep-clear"></div>
<div
  class="fusion-separator fusion-full-width-sep sep-none"
  style="margin-left: auto; margin-right: auto; margin-top: 20px"
></div>

<!-- ACCORDIONS  -->
<form [formGroup]="profileForm" id="profile-appform">
  <div
    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_1 fusion-builder-column-0 fusion-one-full fusion-column-first fusion-column-last 1_1"
    style="margin-top: 0px; margin-bottom: 0px"
  >
    <div
      class="fusion-column-wrapper"
      style="
        padding: 0px;
        background-position: left top;
        background-repeat: no-repeat;
        background-size: cover;
        height: auto;
      "
      data-bg-url=""
    >
      <div class="accordian fusion-accordian">
        <div
          class="panel-group fusion-toggle-icon-right"
          id="dati-personali"
          role="tablist"
        >
          <div
            class="fusion-panel panel-default fusion-toggle-no-divider"
            role="tabpanel"
          >
            <div class="panel-heading">
              <h4
                class="panel-title toggle fusion-responsive-typography-calculated"
                data-fontsize="16"
                data-lineheight="22.08px"
                style="--fontSize: 16; line-height: 1.38; --minFontSize: 16"
              >
                <a
                  id="dati-personali-link"
                  class="active"
                  aria-expanded="true"
                  aria-selected="true"
                  aria-controls="dati-personali-panel"
                  role="tab"
                  data-toggle="collapse"
                  data-target="#dati-personali-panel"
                  href="#dati-personali-panel"
                  ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                    ><i class="fa-fusion-box"></i></span
                  ><span class="fusion-toggle-heading"
                    >I tuoi dati personali</span
                  ></a
                >
              </h4>
              <p class="section-completion-info" *ngIf="!isProfileValid()">
                Non hai ancora compilato questa sezione
              </p>
            </div>
            <div
              id="dati-personali-panel"
              class="panel-collapse collapse in"
              style="height: auto"
            >
              <div class="panel-body toggle-content fusion-clearfix">
                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-11 fusion-one-half fusion-column-first 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4%) * 0.5));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-11"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-1"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa-address-card fas"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">
                            <p>Nome*</p>
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-4 .fusion-button-text,
                          .fusion-button.button-4 i {
                            color: #333333;
                          }

                          .fusion-button.button-4 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-4:hover .fusion-button-text,
                          .fusion-button.button-4:hover i,
                          .fusion-button.button-4:focus .fusion-button-text,
                          .fusion-button.button-4:focus i,
                          .fusion-button.button-4:active .fusion-button-text,
                          .fusion-button.button-4:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-4:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-4:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-4:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-4:hover,
                          .fusion-button.button-4:focus,
                          .fusion-button.button-4:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-4 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-4 {
                            background: #ffffff;
                          }

                          .fusion-button.button-4:hover,
                          .button-4:focus,
                          .fusion-button.button-4:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci nome"
                          class="ng-app-input"
                          type="text"
                          formControlName="firstName"
                          (click)="resetError()"
                          required
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('firstName').valid ||
                              profileForm.get('firstName').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Il nome è obbligatorio.
                        </div>
                      </div>
                      <ul
                        class="fusion-checklist fusion-checklist-2"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-envelope"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">
                            <p>Email*</p>
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-5 .fusion-button-text,
                          .fusion-button.button-5 i {
                            color: #333333;
                          }

                          .fusion-button.button-5 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-5:hover .fusion-button-text,
                          .fusion-button.button-5:hover i,
                          .fusion-button.button-5:focus .fusion-button-text,
                          .fusion-button.button-5:focus i,
                          .fusion-button.button-5:active .fusion-button-text,
                          .fusion-button.button-5:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-5:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-5:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-5:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-5:hover,
                          .fusion-button.button-5:focus,
                          .fusion-button.button-5:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-5 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-5 {
                            background: #ffffff;
                          }

                          .fusion-button.button-5:hover,
                          .button-5:focus,
                          .fusion-button.button-5:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci email"
                          class="ng-app-input"
                          type="email"
                          formControlName="email"
                          (click)="resetError()"
                          required
                          email
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('email').valid ||
                              profileForm.get('email').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Inserire un'email valida.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-12 fusion-one-half fusion-column-last 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4%) * 0.5));
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-12"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-3"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa-address-card fas"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">
                            <p>Cognome*</p>
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-6 .fusion-button-text,
                          .fusion-button.button-6 i {
                            color: #333333;
                          }

                          .fusion-button.button-6 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-6:hover .fusion-button-text,
                          .fusion-button.button-6:hover i,
                          .fusion-button.button-6:focus .fusion-button-text,
                          .fusion-button.button-6:focus i,
                          .fusion-button.button-6:active .fusion-button-text,
                          .fusion-button.button-6:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-6:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-6:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-6:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-6:hover,
                          .fusion-button.button-6:focus,
                          .fusion-button.button-6:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-6 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-6 {
                            background: #ffffff;
                          }

                          .fusion-button.button-6:hover,
                          .button-6:focus,
                          .fusion-button.button-6:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci cognome"
                          class="ng-app-input"
                          type="text"
                          formControlName="lastName"
                          (click)="resetError()"
                          required
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('lastName').valid ||
                              profileForm.get('lastName').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Il cognome è obbligatorio.
                        </div>
                      </div>
                      <ul
                        class="fusion-checklist fusion-checklist-4"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-phone"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">
                            <p>Telefono*</p>
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-7 .fusion-button-text,
                          .fusion-button.button-7 i {
                            color: #333333;
                          }

                          .fusion-button.button-7 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-7:hover .fusion-button-text,
                          .fusion-button.button-7:hover i,
                          .fusion-button.button-7:focus .fusion-button-text,
                          .fusion-button.button-7:focus i,
                          .fusion-button.button-7:active .fusion-button-text,
                          .fusion-button.button-7:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-7:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-7:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-7:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-7:hover,
                          .fusion-button.button-7:focus,
                          .fusion-button.button-7:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-7 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-7 {
                            background: #ffffff;
                          }

                          .fusion-button.button-7:hover,
                          .button-7:focus,
                          .fusion-button.button-7:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci telefono"
                          class="ng-app-input"
                          type="text"
                          formControlName="phone"
                          (click)="resetError()"
                          required
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('phone').valid ||
                              profileForm.get('phone').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Inserire un numero di telefono valido.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SAVE BUTTON  -->

                <!-- <div
                  [ngStyle]="{
                    visibility: error === 'no_error' ? 'hidden' : 'visible'
                  }"
                  class="ng-{{ errorMessageClass }}"
                >
                  {{ error }}
                </div> -->
                <div class="ng-spinner">
                  <img
                    *ngIf="loading"
                    src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
                  />
                </div>
                <div class="fusion-button-wrapper fusion-alignright">
                  <style type="text/css">
                    .fusion-button.button-35 {
                      border-radius: 0px;
                    }
                  </style>
                  <a
                    (click)="closeAccordion('dati-personali-link')"
                    appInvalidControlScroll
                    class="fusion-button button-flat button-large button-default button-35 fusion-button-default-span fusion-button-default-type"
                    target="_self"
                    ><span class="fusion-button-text">Conferma</span></a
                  >
                </div>

                <!-- SAVE BUTTON  -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <style type="text/css">
        #accordion-2089-2 .fusion-panel:hover,
        #accordion-2089-2 .fusion-panel.hover {
          background-color: #f9f9f9;
        }
        #accordion-2089-2 .fusion-panel {
          border-color: #d9d9d9;
          border-width: 1px;
          background-color: #ffffff;
        }
        .fusion-accordian #accordion-2089-2 .panel-title a .fa-fusion-box {
          color: #ffffff;
        }
        .fusion-accordian
          #accordion-2089-2
          .panel-title
          a
          .fa-fusion-box:before {
          font-size: 16px;
          width: 16px;
        }
        .fusion-accordian
          #accordion-2089-2.fusion-toggle-icon-right
          .fusion-toggle-heading {
          margin-right: 34px;
        }
        .fusion-accordian #accordion-2089-2 .panel-title a {
          font-size: 20px;
        }
        .fusion-accordian #accordion-2089-2 .fa-fusion-box {
          background-color: #6d6d6d;
          border-color: #6d6d6d;
        }
        .fusion-accordian #accordion-2089-2 .panel-title a:hover,
        #accordion-2089-2 .fusion-toggle-boxed-mode:hover .panel-title a {
          color: #ffa626;
        }
        .fusion-accordian #accordion-2089-2 .panel-title .active .fa-fusion-box,
        .fusion-accordian
          #accordion-2089-2
          .panel-title
          a:hover
          .fa-fusion-box {
          background-color: #ffa626 !important;
          border-color: #ffa626 !important;
        }
      </style> -->

      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>

      <!-- I DATI DELLA TUA AZIENDA  -->

      <div class="accordian fusion-accordian">
        <div
          class="panel-group fusion-toggle-icon-right"
          id="dati-azienda"
          role="tablist"
        >
          <div
            class="fusion-panel panel-default fusion-toggle-no-divider"
            role="tabpanel"
          >
            <div class="panel-heading">
              <h4
                class="panel-title toggle fusion-responsive-typography-calculated"
                data-fontsize="16"
                data-lineheight="22.08px"
                style="--fontSize: 16; line-height: 1.38; --minFontSize: 16"
              >
                <a
                  id="dati-azienda-link"
                  class="active"
                  aria-expanded="true"
                  aria-selected="true"
                  aria-controls="dati-azienda-panel"
                  role="tab"
                  data-toggle="collapse"
                  data-target="#dati-azienda-panel"
                  href="#dati-azienda-panel"
                  ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                    ><i class="fa-fusion-box"></i></span
                  ><span class="fusion-toggle-heading"
                    >I dati della tua azienda</span
                  ></a
                >
              </h4>
              <p class="section-completion-info" *ngIf="!isBusinessValid()">
                Non hai ancora compilato questa sezione
              </p>
              <p class="section-completion-info" *ngIf="privateRegistry">Se committente azienda compilare i seguenti campi</p>
            </div>
            <div
              id="dati-azienda-panel"
              class="panel-collapse collapse in"
              style="height: auto"
            >
              <div class="panel-body toggle-content fusion-clearfix">
                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-16 fusion-one-half fusion-column-first 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4%) * 0.5));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-16"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-8"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-building"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">
                            <p>Ragione Sociale*</p>
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-11 .fusion-button-text,
                          .fusion-button.button-11 i {
                            color: #333333;
                          }

                          .fusion-button.button-11 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-11:hover .fusion-button-text,
                          .fusion-button.button-11:hover i,
                          .fusion-button.button-11:focus .fusion-button-text,
                          .fusion-button.button-11:focus i,
                          .fusion-button.button-11:active .fusion-button-text,
                          .fusion-button.button-11:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-11:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-11:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-11:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-11:hover,
                          .fusion-button.button-11:focus,
                          .fusion-button.button-11:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-11 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-11 {
                            background: #ffffff;
                          }

                          .fusion-button.button-11:hover,
                          .button-11:focus,
                          .fusion-button.button-11:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci ragione sociale"
                          class="ng-app-input"
                          type="text"
                          formControlName="companyName"
                          (click)="resetError()"
                          required
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('companyName').valid ||
                              profileForm.get('companyName').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          La ragione sociale è obbligatoria.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-17 fusion-one-half fusion-column-last 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4%) * 0.5));
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-17"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-9"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-building"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">
                            <p>Partiva IVA</p>
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-12 .fusion-button-text,
                          .fusion-button.button-12 i {
                            color: #333333;
                          }

                          .fusion-button.button-12 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-12:hover .fusion-button-text,
                          .fusion-button.button-12:hover i,
                          .fusion-button.button-12:focus .fusion-button-text,
                          .fusion-button.button-12:focus i,
                          .fusion-button.button-12:active .fusion-button-text,
                          .fusion-button.button-12:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-12:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-12:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-12:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-12:hover,
                          .fusion-button.button-12:focus,
                          .fusion-button.button-12:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-12 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-12 {
                            background: #ffffff;
                          }

                          .fusion-button.button-12:hover,
                          .button-12:focus,
                          .fusion-button.button-12:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci partita IVA"
                          class="ng-app-input"
                          type="text"
                          formControlName="vatCode"
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('vatCode').valid ||
                              profileForm.get('vatCode').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Inserisci almeno il codice fiscale o la p. IVA.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-18 fusion-one-half fusion-column-first 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4%) * 0.5));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-18"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-10"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-building"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">
                            <p>Codice Fiscale</p>
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-13 .fusion-button-text,
                          .fusion-button.button-13 i {
                            color: #333333;
                          }

                          .fusion-button.button-13 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-13:hover .fusion-button-text,
                          .fusion-button.button-13:hover i,
                          .fusion-button.button-13:focus .fusion-button-text,
                          .fusion-button.button-13:focus i,
                          .fusion-button.button-13:active .fusion-button-text,
                          .fusion-button.button-13:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-13:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-13:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-13:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-13:hover,
                          .fusion-button.button-13:focus,
                          .fusion-button.button-13:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-13 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-13 {
                            background: #ffffff;
                          }

                          .fusion-button.button-13:hover,
                          .button-13:focus,
                          .fusion-button.button-13:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci codice fiscale"
                          class="ng-app-input"
                          type="text"
                          formControlName="fiscalCode"
                          (click)="resetError()"
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('fiscalCode').valid ||
                              profileForm.get('fiscalCode').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Inserire un codice fiscale valido.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-19 fusion-one-half fusion-column-last 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4%) * 0.5));
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-19"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-11"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-envelope"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">
                            <p>PEC</p>
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-14 .fusion-button-text,
                          .fusion-button.button-14 i {
                            color: #333333;
                          }

                          .fusion-button.button-14 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-14:hover .fusion-button-text,
                          .fusion-button.button-14:hover i,
                          .fusion-button.button-14:focus .fusion-button-text,
                          .fusion-button.button-14:focus i,
                          .fusion-button.button-14:active .fusion-button-text,
                          .fusion-button.button-14:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-14:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-14:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-14:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-14:hover,
                          .fusion-button.button-14:focus,
                          .fusion-button.button-14:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-14 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-14 {
                            background: #ffffff;
                          }

                          .fusion-button.button-14:hover,
                          .button-14:focus,
                          .fusion-button.button-14:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci PEC"
                          class="ng-app-input"
                          type="text"
                          formControlName="pec"
                          (click)="resetError()"
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('pec').valid ||
                              profileForm.get('pec').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Inserire una pec valida.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-20 fusion-one-half fusion-column-first 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4%) * 0.5));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-20"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-12"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-archive"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">
                            <p>Cod. SDI Per Fatturazione</p>
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-15 .fusion-button-text,
                          .fusion-button.button-15 i {
                            color: #333333;
                          }

                          .fusion-button.button-15 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-15:hover .fusion-button-text,
                          .fusion-button.button-15:hover i,
                          .fusion-button.button-15:focus .fusion-button-text,
                          .fusion-button.button-15:focus i,
                          .fusion-button.button-15:active .fusion-button-text,
                          .fusion-button.button-15:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-15:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-15:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-15:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-15:hover,
                          .fusion-button.button-15:focus,
                          .fusion-button.button-15:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-15 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-15 {
                            background: #ffffff;
                          }

                          .fusion-button.button-15:hover,
                          .button-15:focus,
                          .fusion-button.button-15:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci codice SDI"
                          class="ng-app-input"
                          type="text"
                          formControlName="sdiCode"
                          (click)="resetError()"
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('sdiCode').valid ||
                              profileForm.get('sdiCode').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Il codice sdi o la pec sono obbligatori.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-21 fusion-one-half fusion-column-last 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4%) * 0.5));
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-21"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-13"
                        style="font-size: 16px; line-height: 27.2px"
                      ></ul>
                    </div>
                  </div>
                </div>

                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                  *ngIf="showhidedesigner"
                >
                  <h5><strong>ISCRIZIONE AD UN ALBO (NP)</strong></h5>
                  <div class="fusion-sep-clear"></div>
                  <div
                    class="fusion-separator fusion-full-width-sep sep-none"
                    style="
                      margin-left: auto;
                      margin-right: auto;
                      margin-top: 15px;
                    "
                  ></div>
                  <div
                    class="fusion-builder-row fusion-builder-row-inner fusion-row"
                  >
                    <div
                      class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-13 fusion-one-half fusion-column-first 1_2"
                      style="
                        margin-top: 0px;
                        margin-bottom: 0px;
                        width: 50%;
                        width: calc(50% - ((4% + 4%) * 0.5));
                        margin-right: 4%;
                      "
                    >
                      <div
                        class="fusion-column-wrapper fusion-column-wrapper-13"
                        style="
                          padding: 0px 0px 0px 0px;
                          background-position: left top;
                          background-repeat: no-repeat;
                          -webkit-background-size: cover;
                          -moz-background-size: cover;
                          -o-background-size: cover;
                          background-size: cover;
                        "
                        data-bg-url=""
                      >
                        <ul
                          class="fusion-checklist fusion-checklist-5"
                          style="font-size: 16px; line-height: 27.2px"
                        >
                          <li class="fusion-li-item">
                            <!-- <span
                              style="
                                height: 27.2px;
                                width: 27.2px;
                                margin-right: 11.2px;
                              "
                              class="icon-wrapper circle-no"
                              ><i
                                class="fusion-li-icon fa fa-id-card-alt"
                                style="color: #333333"
                              ></i
                            ></span> -->
                            <div class="fusion-li-item-content">
                              Albo Di Appartenenza
                            </div>
                          </li>
                        </ul>
                        <div class="fusion-button-wrapper fusion-align-block">
                          <style type="text/css">
                            .fusion-button.button-8 .fusion-button-text,
                            .fusion-button.button-8 i {
                              color: #333333;
                            }

                            .fusion-button.button-8
                              .fusion-button-icon-divider {
                              border-color: #333333;
                            }

                            .fusion-button.button-8:hover .fusion-button-text,
                            .fusion-button.button-8:hover i,
                            .fusion-button.button-8:focus .fusion-button-text,
                            .fusion-button.button-8:focus i,
                            .fusion-button.button-8:active .fusion-button-text,
                            .fusion-button.button-8:active {
                              color: #ffffff;
                            }

                            .fusion-button.button-8:hover
                              .fusion-button-icon-divider,
                            .fusion-button.button-8:hover
                              .fusion-button-icon-divider,
                            .fusion-button.button-8:active
                              .fusion-button-icon-divider {
                              border-color: #ffffff;
                            }

                            .fusion-button.button-8:hover,
                            .fusion-button.button-8:focus,
                            .fusion-button.button-8:active {
                              border-color: #ffffff;
                            }

                            .fusion-button.button-8 {
                              border-color: #333333;
                              border-radius: 0px;
                            }

                            .fusion-button.button-8 {
                              background: #ffffff;
                            }

                            .fusion-button.button-8:hover,
                            .button-8:focus,
                            .fusion-button.button-8:active {
                              background: #ffffff;
                            }
                          </style>
                          <select formControlName="registrySubscriptionCode">
                            <option [ngValue]="null">
                              Seleziona albo di appartenenza
                            </option>
                            <option
                              [ngValue]="professionalRegistry.code"
                              *ngFor="
                                let professionalRegistry of professionalRegistryList
                              "
                            >
                              {{ professionalRegistry.description }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div
                      class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-14 fusion-one-fourth 1_4"
                      style="
                        margin-top: 0px;
                        margin-bottom: 0px;
                        width: 25%;
                        width: calc(25% - ((4% + 4%) * 0.25));
                        margin-right: 4%;
                      "
                    >
                      <div
                        class="fusion-column-wrapper fusion-column-wrapper-14"
                        style="
                          padding: 0px 0px 0px 0px;
                          background-position: left top;
                          background-repeat: no-repeat;
                          -webkit-background-size: cover;
                          -moz-background-size: cover;
                          -o-background-size: cover;
                          background-size: cover;
                        "
                        data-bg-url=""
                      >
                        <ul
                          class="fusion-checklist fusion-checklist-6"
                          style="font-size: 16px; line-height: 27.2px"
                        >
                          <li class="fusion-li-item">
                            <!-- <span
                              style="
                                height: 27.2px;
                                width: 27.2px;
                                margin-right: 11.2px;
                              "
                              class="icon-wrapper circle-no"
                              ><i
                                class="fusion-li-icon fa fa-id-card-alt"
                                style="color: #333333"
                              ></i
                            ></span> -->
                            <div class="fusion-li-item-content">Provincia</div>
                          </li>
                        </ul>
                        <div class="fusion-button-wrapper fusion-align-block">
                          <style type="text/css">
                            .fusion-button.button-9 .fusion-button-text,
                            .fusion-button.button-9 i {
                              color: #333333;
                            }

                            .fusion-button.button-9
                              .fusion-button-icon-divider {
                              border-color: #333333;
                            }

                            .fusion-button.button-9:hover .fusion-button-text,
                            .fusion-button.button-9:hover i,
                            .fusion-button.button-9:focus .fusion-button-text,
                            .fusion-button.button-9:focus i,
                            .fusion-button.button-9:active .fusion-button-text,
                            .fusion-button.button-9:active {
                              color: #ffffff;
                            }

                            .fusion-button.button-9:hover
                              .fusion-button-icon-divider,
                            .fusion-button.button-9:hover
                              .fusion-button-icon-divider,
                            .fusion-button.button-9:active
                              .fusion-button-icon-divider {
                              border-color: #ffffff;
                            }

                            .fusion-button.button-9:hover,
                            .fusion-button.button-9:focus,
                            .fusion-button.button-9:active {
                              border-color: #ffffff;
                            }

                            .fusion-button.button-9 {
                              border-color: #333333;
                              border-radius: 0px;
                            }

                            .fusion-button.button-9 {
                              background: #ffffff;
                            }

                            .fusion-button.button-9:hover,
                            .button-9:focus,
                            .fusion-button.button-9:active {
                              background: #ffffff;
                            }
                          </style>
                          <select
                            formControlName="registrySubscriptionProvince"
                          >
                            <option [ngValue]="null">
                              Seleziona provincia
                            </option>
                            <option
                              [ngValue]="province.code"
                              *ngFor="let province of provinces"
                            >
                              {{ province.description }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div
                      class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-15 fusion-one-fourth fusion-column-last 1_4"
                      style="
                        margin-top: 0px;
                        margin-bottom: 0px;
                        width: 25%;
                        width: calc(25% - ((4% + 4%) * 0.25));
                      "
                    >
                      <div
                        class="fusion-column-wrapper fusion-column-wrapper-15"
                        style="
                          padding: 0px 0px 0px 0px;
                          background-position: left top;
                          background-repeat: no-repeat;
                          -webkit-background-size: cover;
                          -moz-background-size: cover;
                          -o-background-size: cover;
                          background-size: cover;
                        "
                        data-bg-url=""
                      >
                        <ul
                          class="fusion-checklist fusion-checklist-7"
                          style="font-size: 16px; line-height: 27.2px"
                        >
                          <li class="fusion-li-item">
                            <!-- <span
                              style="
                                height: 27.2px;
                                width: 27.2px;
                                margin-right: 11.2px;
                              "
                              class="icon-wrapper circle-no"
                              ><i
                                class="fusion-li-icon fa fa-id-card-alt"
                                style="color: #333333"
                              ></i
                            ></span> -->
                            <div class="fusion-li-item-content">N° Iscriz.</div>
                          </li>
                        </ul>
                        <div class="fusion-button-wrapper fusion-align-block">
                          <style type="text/css">
                            .fusion-button.button-10 .fusion-button-text,
                            .fusion-button.button-10 i {
                              color: #333333;
                            }

                            .fusion-button.button-10
                              .fusion-button-icon-divider {
                              border-color: #333333;
                            }

                            .fusion-button.button-10:hover .fusion-button-text,
                            .fusion-button.button-10:hover i,
                            .fusion-button.button-10:focus .fusion-button-text,
                            .fusion-button.button-10:focus i,
                            .fusion-button.button-10:active .fusion-button-text,
                            .fusion-button.button-10:active {
                              color: #ffffff;
                            }

                            .fusion-button.button-10:hover
                              .fusion-button-icon-divider,
                            .fusion-button.button-10:hover
                              .fusion-button-icon-divider,
                            .fusion-button.button-10:active
                              .fusion-button-icon-divider {
                              border-color: #ffffff;
                            }

                            .fusion-button.button-10:hover,
                            .fusion-button.button-10:focus,
                            .fusion-button.button-10:active {
                              border-color: #ffffff;
                            }

                            .fusion-button.button-10 {
                              border-color: #333333;
                              border-radius: 0px;
                            }

                            .fusion-button.button-10 {
                              background: #ffffff;
                            }

                            .fusion-button.button-10:hover,
                            .button-10:focus,
                            .fusion-button.button-10:active {
                              background: #ffffff;
                            }
                          </style>
                          <input
                            placeholder="Inserisci numero iscrizione"
                            class="ng-app-input"
                            type="text"
                            formControlName="registrySubscriptionNumber"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="fusion-sep-clear"></div>
                  <div
                    class="fusion-separator fusion-full-width-sep sep-none"
                    style="
                      margin-left: auto;
                      margin-right: auto;
                      margin-top: 20px;
                    "
                  ></div>
                </div>

                <!-- SAVE BUTTON  -->

                <!-- <div
                  [ngStyle]="{
                    visibility: error === 'no_error' ? 'hidden' : 'visible'
                  }"
                  class="ng-{{ errorMessageClass }}"
                >
                  {{ error }}
                </div> -->
                <div class="ng-spinner">
                  <img
                    *ngIf="loading"
                    src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
                  />
                </div>
                <div class="fusion-button-wrapper fusion-alignright">
                  <style type="text/css">
                    .fusion-button.button-35 {
                      border-radius: 0px;
                    }
                  </style>
                  <a
                    (click)="closeAccordion('dati-azienda-link')"
                    appInvalidControlScroll
                    class="fusion-button button-flat button-large button-default button-35 fusion-button-default-span fusion-button-default-type"
                    target="_self"
                    ><span class="fusion-button-text">Conferma</span></a
                  >
                </div>

                <!-- SAVE BUTTON  -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <style type="text/css">
        #accordion-2089-3 .fusion-panel:hover,
        #accordion-2089-3 .fusion-panel.hover {
          background-color: #f9f9f9;
        }
        #accordion-2089-3 .fusion-panel {
          border-color: #d9d9d9;
          border-width: 1px;
          background-color: #ffffff;
        }
        .fusion-accordian #accordion-2089-3 .panel-title a .fa-fusion-box {
          color: #ffffff;
        }
        .fusion-accordian
          #accordion-2089-3
          .panel-title
          a
          .fa-fusion-box:before {
          font-size: 16px;
          width: 16px;
        }
        .fusion-accordian
          #accordion-2089-3.fusion-toggle-icon-right
          .fusion-toggle-heading {
          margin-right: 34px;
        }
        .fusion-accordian #accordion-2089-3 .panel-title a {
          font-size: 25px;
        }
        .fusion-accordian #accordion-2089-3 .fa-fusion-box {
          background-color: #6d6d6d;
          border-color: #6d6d6d;
        }
        .fusion-accordian #accordion-2089-3 .panel-title a:hover,
        #accordion-2089-3 .fusion-toggle-boxed-mode:hover .panel-title a {
          color: #ffa626;
        }
        .fusion-accordian #accordion-2089-3 .panel-title .active .fa-fusion-box,
        .fusion-accordian
          #accordion-2089-3
          .panel-title
          a:hover
          .fa-fusion-box {
          background-color: #ffa626 !important;
          border-color: #ffa626 !important;
        }
      </style> -->

      <div class="fusion-sep-clear"></div>
      <div
        *ngIf="!privateRegistry"
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>

      <!-- SETTORE E DETTAGLIO IMPRESA  -->

      <div class="accordian fusion-accordian" *ngIf="!privateRegistry">
        <div
          class="panel-group fusion-toggle-icon-right"
          id="settore-dettaglio"
          role="tablist"
        >
          <div
            class="fusion-panel panel-default fusion-toggle-no-divider"
            role="tabpanel"
          >
            <div class="panel-heading">
              <h4
                class="panel-title toggle fusion-responsive-typography-calculated"
                data-fontsize="16"
                data-lineheight="22.08px"
                style="--fontSize: 16; line-height: 1.38; --minFontSize: 16"
              >
                <a
                  id="settore-dettaglio-link"
                  class="active"
                  aria-expanded="true"
                  aria-selected="true"
                  aria-controls="settore-dettaglio-panel"
                  role="tab"
                  data-toggle="collapse"
                  data-target="#settore-dettaglio-panel"
                  href="#settore-dettaglio-panel"
                  ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                    ><i class="fa-fusion-box"></i></span
                  ><span class="fusion-toggle-heading"
                    >Settore e dettaglio {{showhidedesigner ? "studio" : "impresa"}}</span
                  ></a
                >
              </h4>
              <p class="section-completion-info" *ngIf="!isDetailSectorValid()">
                Non hai ancora compilato questa sezione
              </p>
            </div>
            <div
              id="settore-dettaglio-panel"
              class="panel-collapse collapse in"
              style="height: auto"
            >
              <div class="panel-body toggle-content fusion-clearfix">
                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                  style="display: flex; flex-wrap: wrap"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-nested-column-30 fusion-two-third fusion-column-first 2_3"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 66.66%;
                      width: calc(50% - ((4% + 4%) * 0.5));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-30"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-22"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa-address-card fas"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">
                            Datore Di Lavoro
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-24 .fusion-button-text,
                          .fusion-button.button-24 i {
                            color: #333333;
                          }

                          .fusion-button.button-24 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-24:hover .fusion-button-text,
                          .fusion-button.button-24:hover i,
                          .fusion-button.button-24:focus .fusion-button-text,
                          .fusion-button.button-24:focus i,
                          .fusion-button.button-24:active .fusion-button-text,
                          .fusion-button.button-24:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-24:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-24:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-24:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-24:hover,
                          .fusion-button.button-24:focus,
                          .fusion-button.button-24:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-24 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-24 {
                            background: #ffffff;
                          }

                          .fusion-button.button-24:hover,
                          .button-24:focus,
                          .fusion-button.button-24:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci datore di lavoro"
                          class="ng-app-input"
                          type="text"
                          formControlName="employer"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- n. dipendenti -->
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-13 fusion-one-half fusion-column-first 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4% + 4%) * 0.5));
                      margin-left: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-13"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-5"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-id-card-alt"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">
                            N° Dipendenti
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-8 .fusion-button-text,
                          .fusion-button.button-8 i {
                            color: #333333;
                          }

                          .fusion-button.button-8 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-8:hover .fusion-button-text,
                          .fusion-button.button-8:hover i,
                          .fusion-button.button-8:focus .fusion-button-text,
                          .fusion-button.button-8:focus i,
                          .fusion-button.button-8:active .fusion-button-text,
                          .fusion-button.button-8:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-8:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-8:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-8:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-8:hover,
                          .fusion-button.button-8:focus,
                          .fusion-button.button-8:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-8 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-8 {
                            background: #ffffff;
                          }

                          .fusion-button.button-8:hover,
                          .button-8:focus,
                          .fusion-button.button-8:active {
                            background: #ffffff;
                          }
                        </style>
                        <select formControlName="companySizeCode">
                          <option [ngValue]="null">
                            Seleziona n. dipendenti
                          </option>
                          <option
                            [ngValue]="companySize.code"
                            *ngFor="let companySize of companySizeList"
                          >
                            {{ companySize.description }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                  style="display: flex; flex-wrap: wrap"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-13 fusion-one-half fusion-column-first 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4% + 4%) * 0.5));
                      margin-right: 4%;
                    "
                  >
                    <div
                      *ngIf="!showhidedesigner"
                      class="fusion-column-wrapper fusion-column-wrapper-13"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-5"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-id-card-alt"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">Tipo Impresa</div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-8 .fusion-button-text,
                          .fusion-button.button-8 i {
                            color: #333333;
                          }

                          .fusion-button.button-8 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-8:hover .fusion-button-text,
                          .fusion-button.button-8:hover i,
                          .fusion-button.button-8:focus .fusion-button-text,
                          .fusion-button.button-8:focus i,
                          .fusion-button.button-8:active .fusion-button-text,
                          .fusion-button.button-8:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-8:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-8:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-8:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-8:hover,
                          .fusion-button.button-8:focus,
                          .fusion-button.button-8:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-8 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-8 {
                            background: #ffffff;
                          }

                          .fusion-button.button-8:hover,
                          .button-8:focus,
                          .fusion-button.button-8:active {
                            background: #ffffff;
                          }
                        </style>
                        <select
                          formControlName="typeCode"
                          placeholder="Seleziona tipo impresa"
                        >
                          <option [ngValue]="null" *ngIf="showhidedesigner">
                            Seleziona tipo impresa
                          </option>
                          <option
                            [ngValue]="typeCompany.code"
                            *ngFor="let typeCompany of typeCompanyList"
                          >
                            {{ typeCompany.description }}
                          </option>
                        </select>
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('typeCode').valid ||
                              profileForm.get('typeCode').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Il tipo impresa è obbligatorio.
                        </div>
                      </div>
                    </div>

                    <div
                      *ngIf="showhidedesigner"
                      class="fusion-column-wrapper fusion-column-wrapper-13"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-5"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <div class="fusion-li-item-content">Tipo Società</div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-8 .fusion-button-text,
                          .fusion-button.button-8 i {
                            color: #333333;
                          }

                          .fusion-button.button-8 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-8:hover .fusion-button-text,
                          .fusion-button.button-8:hover i,
                          .fusion-button.button-8:focus .fusion-button-text,
                          .fusion-button.button-8:focus i,
                          .fusion-button.button-8:active .fusion-button-text,
                          .fusion-button.button-8:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-8:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-8:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-8:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-8:hover,
                          .fusion-button.button-8:focus,
                          .fusion-button.button-8:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-8 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-8 {
                            background: #ffffff;
                          }

                          .fusion-button.button-8:hover,
                          .button-8:focus,
                          .fusion-button.button-8:active {
                            background: #ffffff;
                          }
                        </style>
                        <select formControlName="typeCode">
                          <option [ngValue]="null" *ngIf="!showhidedesigner">
                            Seleziona tipo società
                          </option>
                          <option
                            [ngValue]="typeCompany.code"
                            *ngFor="let typeCompany of typeProfessionalList"
                          >
                            {{ typeCompany.description }}
                          </option>
                        </select>
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('typeCode').valid ||
                              profileForm.get('typeCode').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Il tipo società è obbligatorio.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    *ngIf="showhidedesigner"
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-13 fusion-one-half fusion-column-last 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4% + 4%) * 0.5));
                      margin-left: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-13"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-5"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <div class="fusion-li-item-content">
                            Titolo Professionale
                          </div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-8 .fusion-button-text,
                          .fusion-button.button-8 i {
                            color: #333333;
                          }

                          .fusion-button.button-8 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-8:hover .fusion-button-text,
                          .fusion-button.button-8:hover i,
                          .fusion-button.button-8:focus .fusion-button-text,
                          .fusion-button.button-8:focus i,
                          .fusion-button.button-8:active .fusion-button-text,
                          .fusion-button.button-8:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-8:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-8:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-8:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-8:hover,
                          .fusion-button.button-8:focus,
                          .fusion-button.button-8:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-8 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-8 {
                            background: #ffffff;
                          }

                          .fusion-button.button-8:hover,
                          .button-8:focus,
                          .fusion-button.button-8:active {
                            background: #ffffff;
                          }
                        </style>
                        <select formControlName="sectorCode" id="sectorCode">
                          <option [ngValue]="null" *ngIf="!showhidedesigner">
                            Seleziona settore
                          </option>
                          <option
                            [ngValue]="sectorCompany.code"
                            *ngFor="let sectorCompany of sectorProfessionalList"
                          >
                            {{ sectorCompany.description }}
                          </option>
                        </select>
                        <div
                          [ngStyle]="{
                            visibility:
                              sectorCodeMessage === 'no_error'
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          {{ sectorCodeMessage }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="fusion-sep-clear"></div>
                <div
                  class="fusion-button-wrapper fusion-align-block"
                  *ngIf="!showhidedesigner"
                >
                  <style type="text/css">
                    .fusion-button.button-1 .fusion-button-text,
                    .fusion-button.button-1 i {
                      color: #a5a5a5;
                    }

                    .fusion-button.button-1 .fusion-button-icon-divider {
                      border-color: #a5a5a5;
                    }

                    .fusion-button.button-1:hover .fusion-button-text,
                    .fusion-button.button-1:hover i,
                    .fusion-button.button-1:focus .fusion-button-text,
                    .fusion-button.button-1:focus i,
                    .fusion-button.button-1:active .fusion-button-text,
                    .fusion-button.button-1:active {
                      color: #ffffff;
                    }

                    .fusion-button.button-1:hover .fusion-button-icon-divider,
                    .fusion-button.button-1:hover .fusion-button-icon-divider,
                    .fusion-button.button-1:active .fusion-button-icon-divider {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-1:hover,
                    .fusion-button.button-1:focus,
                    .fusion-button.button-1:active {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-1 {
                      border-color: #333333;
                      border-radius: 0px;
                    }

                    .fusion-button.button-1 {
                      background: #ffffff;
                    }

                    .fusion-button.button-1:hover,
                    .button-1:focus,
                    .fusion-button.button-1:active {
                      background: #ffffff;
                    }
                  </style>
                  <ul
                    class="fusion-checklist fusion-checklist-16"
                    style="font-size: 16px; line-height: 27.2px"
                  >
                    <li class="fusion-li-item">
                      <input
                        type="checkbox"
                        id="flagGeneralContractor"
                        formControlName="generalContractor"
                        class="yellowBorderedCheckbox"
                      />
                      <label for="flagGeneralContractor"
                        ><span></span>Appaltatore generale (capo
                        commessa)</label
                      >
                    </li>
                  </ul>
                </div>
                <!-- checkbox appaltatore di settore o parziale -->
                <div class="fusion-sep-clear"></div>
                <div
                  class="fusion-button-wrapper fusion-align-block"
                  *ngIf="!showhidedesigner"
                >
                  <style type="text/css">
                    .fusion-button.button-1 .fusion-button-text,
                    .fusion-button.button-1 i {
                      color: #a5a5a5;
                    }

                    .fusion-button.button-1 .fusion-button-icon-divider {
                      border-color: #a5a5a5;
                    }

                    .fusion-button.button-1:hover .fusion-button-text,
                    .fusion-button.button-1:hover i,
                    .fusion-button.button-1:focus .fusion-button-text,
                    .fusion-button.button-1:focus i,
                    .fusion-button.button-1:active .fusion-button-text,
                    .fusion-button.button-1:active {
                      color: #ffffff;
                    }

                    .fusion-button.button-1:hover .fusion-button-icon-divider,
                    .fusion-button.button-1:hover .fusion-button-icon-divider,
                    .fusion-button.button-1:active .fusion-button-icon-divider {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-1:hover,
                    .fusion-button.button-1:focus,
                    .fusion-button.button-1:active {
                      border-color: #ffffff;
                    }

                    .fusion-button.button-1 {
                      border-color: #333333;
                      border-radius: 0px;
                    }

                    .fusion-button.button-1 {
                      background: #ffffff;
                    }

                    .fusion-button.button-1:hover,
                    .button-1:focus,
                    .fusion-button.button-1:active {
                      background: #ffffff;
                    }
                  </style>
                  <ul
                    class="fusion-checklist fusion-checklist-16"
                    style="font-size: 16px; line-height: 27.2px"
                  >
                    <li class="fusion-li-item">
                      <input
                        type="checkbox"
                        id="flagSectorContractor"
                        formControlName="sectorOrPartialContractor"
                        class="yellowBorderedCheckbox"
                      />
                      <label for="flagSectorContractor"
                        ><span></span>APPALTATORE DI SETTORE/TERZISTA(es:
                        idraulico; elettricista; lattoniere; intonaci;
                        tinteggiatore; pavimentista; giardiniere; ecc)</label
                      >
                    </li>
                  </ul>
                </div>

                <!-- SETTORE IMPRESA ACCORDION  -->

                <div
                  *ngIf="!showhidedesigner"
                  class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-nested-column-25 fusion-two-third fusion-column-first 2_3"
                  style="
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width: 66.66%;
                    width: calc(66.66% - ((4%) * 0.6666));
                    margin-right: 4%;
                  "
                >
                  <div
                    class="fusion-column-wrapper fusion-column-wrapper-25"
                    style="
                      padding: 0px 0px 0px 0px;
                      background-position: left top;
                      background-repeat: no-repeat;
                      -webkit-background-size: cover;
                      -moz-background-size: cover;
                      -o-background-size: cover;
                      background-size: cover;
                    "
                    data-bg-url=""
                  >
                    <p><strong>SETTORE IMPRESA</strong></p>
                  </div>
                  <div
                    *ngIf="!showhidedesigner"
                    [ngStyle]="{
                      visibility:
                        sectorCodesMessage === 'no_error' ? 'hidden' : 'visible'
                    }"
                    class="ng-alert"
                  >
                    {{ sectorCodesMessage }}
                  </div>
                </div>
                <div
                  *ngIf="!showhidedesigner"
                  class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-26 fusion-one-third fusion-column-last 1_3"
                  style="
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width: 33.33%;
                    width: calc(33.33% - ((4%) * 0.3333));
                  "
                >
                  <div
                    class="fusion-column-wrapper fusion-column-wrapper-26"
                    style="
                      padding: 0px 0px 0px 0px;
                      background-position: left top;
                      background-repeat: no-repeat;
                      -webkit-background-size: cover;
                      -moz-background-size: cover;
                      -o-background-size: cover;
                      background-size: cover;
                    "
                    data-bg-url=""
                  >
                    <div
                      id="sectorCodes"
                      class="fusion-button-wrapper fusion-align-block"
                      *ngIf="addSectorButtonVisible"
                    >
                      <style type="text/css">
                        .fusion-button.button-28 {
                          border-radius: 0px;
                        }
                      </style>
                      <a
                        (click)="addSector()"
                        class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                        target="_self"
                        ><span class="fusion-button-text">Aggiungi</span></a
                      >
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="!showhidedesigner"
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                  style="display: flex; flex-wrap: wrap"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-nested-column-25 fusion-two-third fusion-column-first 2_3"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 100%;
                      width: calc(100%);
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-13"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <div
                        class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-26 fusion-one-third fusion-column-last 1_3"
                        style="
                          margin-top: 0px;
                          margin-bottom: 0px;
                          width: 33.33%;
                          width: calc(33.33% - ((4%) * 0.3333));
                        "
                      ></div>

                      <div *ngFor="let sectorItemCode of sectorCodes">
                        <div
                          class="fusion-separator fusion-full-width-sep sep-none"
                          style="
                            margin-left: auto;
                            margin-right: auto;
                            margin-top: 15px;
                          "
                        ></div>
                        <div class="specialization-container">
                          <div
                            class="fusion-builder-row fusion-builder-row-inner fusion-row"
                          >
                            <div
                              class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-11 fusion-one-half fusion-column-first 1_2"
                              style="
                                margin-top: 0px;
                                margin-bottom: 0px;
                                width: 50%;
                                width: calc(50% - ((4%) * 0.5));
                                margin-right: 4%;
                              "
                            >
                              <div
                                class="fusion-column-wrapper fusion-column-wrapper-11"
                                style="
                                  padding: 0px 0px 0px 0px;
                                  background-position: left top;
                                  background-repeat: no-repeat;
                                  -webkit-background-size: cover;
                                  -moz-background-size: cover;
                                  -o-background-size: cover;
                                  background-size: cover;
                                "
                                data-bg-url=""
                              >
                                <ul
                                  class="fusion-checklist fusion-checklist-15"
                                  style="font-size: 16px; line-height: 27.2px"
                                >
                                  <li class="fusion-li-item">
                                    <div class="fusion-li-item-content">
                                      Settore*
                                    </div>
                                  </li>
                                </ul>
                                <div
                                  class="fusion-button-wrapper fusion-align-block"
                                >
                                  <style type="text/css">
                                    .fusion-button.button-17
                                      .fusion-button-text,
                                    .fusion-button.button-17 i {
                                      color: #333333;
                                    }

                                    .fusion-button.button-17
                                      .fusion-button-icon-divider {
                                      border-color: #333333;
                                    }

                                    .fusion-button.button-17:hover
                                      .fusion-button-text,
                                    .fusion-button.button-17:hover i,
                                    .fusion-button.button-17:focus
                                      .fusion-button-text,
                                    .fusion-button.button-17:focus i,
                                    .fusion-button.button-17:active
                                      .fusion-button-text,
                                    .fusion-button.button-17:active {
                                      color: #ffffff;
                                    }

                                    .fusion-button.button-17:hover
                                      .fusion-button-icon-divider,
                                    .fusion-button.button-17:hover
                                      .fusion-button-icon-divider,
                                    .fusion-button.button-17:active
                                      .fusion-button-icon-divider {
                                      border-color: #ffffff;
                                    }

                                    .fusion-button.button-17:hover,
                                    .fusion-button.button-17:focus,
                                    .fusion-button.button-17:active {
                                      border-color: #ffffff;
                                    }

                                    .fusion-button.button-17 {
                                      border-color: #333333;
                                      border-radius: 0px;
                                    }

                                    .fusion-button.button-17 {
                                      background: #ffffff;
                                    }

                                    .fusion-button.button-17:hover,
                                    .button-17:focus,
                                    .fusion-button.button-17:active {
                                      background: #ffffff;
                                    }
                                  </style>
                                  <select
                                    [(ngModel)]="sectorItemCode.sector"
                                    [ngModelOptions]="{ standalone: true }"
                                    class="manual-validation-valid"
                                  >
                                    <option [ngValue]="null">
                                      Seleziona il settore
                                    </option>
                                    <option
                                      [ngValue]="sectorCompany.code"
                                      *ngFor="
                                        let sectorCompany of sectorCompanyList
                                      "
                                    >
                                      {{ sectorCompany.description }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div
                              class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-24 fusion-one-fourth fusion-column-last 1_4"
                              style="
                                margin-top: 0px;
                                margin-bottom: 0px;
                                width: 23%;
                                width: calc(23% - ((4% + 4%) * 0.25));
                              "
                            >
                              <div
                                class="fusion-column-wrapper fusion-column-wrapper-24"
                                style="
                                  padding: 0px 0px 0px 0px;
                                  background-position: left top;
                                  background-repeat: no-repeat;
                                  -webkit-background-size: cover;
                                  -moz-background-size: cover;
                                  -o-background-size: cover;
                                  background-size: cover;
                                "
                                data-bg-url=""
                              >
                                <div
                                  class="fusion-separator fusion-full-width-sep sep-none"
                                  style="
                                    margin-left: auto;
                                    margin-right: auto;
                                    margin-top: 40px;
                                  "
                                ></div>
                                <div
                                  class="fusion-button-wrapper fusion-align-block"
                                >
                                  <style type="text/css">
                                    .fusion-button.button-28 {
                                      border-radius: 0px;
                                    }
                                  </style>
                                  <a
                                    (click)="removeSector(sectorItemCode)"
                                    class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                                    target="_self"
                                    ><span class="fusion-button-text"
                                      >Rimuovi</span
                                    ></a
                                  >
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            class="fusion-separator fusion-full-width-sep sep-none"
                            style="
                              margin-left: auto;
                              margin-right: auto;
                              margin-top: 15px;
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SETTORE IMPRESA ACCORDION -->

                <!-- SAVE BUTTON  -->

                <div class="fusion-sep-clear"></div>
                <div
                  *ngIf="!privateRegistry"
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 20px;
                  "
                ></div>

                <!-- <div
                  [ngStyle]="{
                    visibility: error === 'no_error' ? 'hidden' : 'visible'
                  }"
                  class="ng-{{ errorMessageClass }}"
                >
                  {{ error }}
                </div> -->
                <div class="ng-spinner">
                  <img
                    *ngIf="loading"
                    src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
                  />
                </div>
                <div class="fusion-button-wrapper fusion-alignright">
                  <style type="text/css">
                    .fusion-button.button-35 {
                      border-radius: 0px;
                    }
                  </style>
                  <a
                    (click)="closeAccordion('settore-dettaglio-link')"
                    appInvalidControlScroll
                    class="fusion-button button-flat button-large button-default button-35 fusion-button-default-span fusion-button-default-type"
                    target="_self"
                    ><span class="fusion-button-text">Conferma</span></a
                  >
                </div>

                <!-- SAVE BUTTON  -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <style type="text/css">
        #accordion-2089-4 .fusion-panel:hover,
        #accordion-2089-4 .fusion-panel.hover {
          background-color: #f9f9f9;
        }
        #accordion-2089-4 .fusion-panel {
          border-color: #d9d9d9;
          border-width: 1px;
          background-color: #ffffff;
        }
        .fusion-accordian #accordion-2089-4 .panel-title a .fa-fusion-box {
          color: #ffffff;
        }
        .fusion-accordian
          #accordion-2089-4
          .panel-title
          a
          .fa-fusion-box:before {
          font-size: 16px;
          width: 16px;
        }
        .fusion-accordian
          #accordion-2089-4.fusion-toggle-icon-right
          .fusion-toggle-heading {
          margin-right: 34px;
        }
        .fusion-accordian #accordion-2089-4 .panel-title a {
          font-size: 25px;
        }
        .fusion-accordian #accordion-2089-4 .fa-fusion-box {
          background-color: #6d6d6d;
          border-color: #6d6d6d;
        }
        .fusion-accordian #accordion-2089-4 .panel-title a:hover,
        #accordion-2089-4 .fusion-toggle-boxed-mode:hover .panel-title a {
          color: #ffa626;
        }
        .fusion-accordian #accordion-2089-4 .panel-title .active .fa-fusion-box,
        .fusion-accordian
          #accordion-2089-4
          .panel-title
          a:hover
          .fa-fusion-box {
          background-color: #ffa626 !important;
          border-color: #ffa626 !important;
        }
      </style> -->

      <div class="fusion-sep-clear"></div>
      <div
        *ngIf="!privateRegistry"
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>

      <!-- SEDE LEGALE  -->

      <div class="accordian fusion-accordian" *ngIf="!privateRegistry">
        <div
          class="panel-group fusion-toggle-icon-right"
          id="sede-legale"
          role="tablist"
        >
          <div
            class="fusion-panel panel-default fusion-toggle-no-divider"
            role="tabpanel"
          >
            <div class="panel-heading">
              <h4
                class="panel-title toggle fusion-responsive-typography-calculated"
                data-fontsize="16"
                data-lineheight="22.08px"
                style="--fontSize: 16; line-height: 1.38; --minFontSize: 16"
              >
                <a
                  id="sede-legale-link"
                  class="active"
                  aria-expanded="true"
                  aria-selected="true"
                  aria-controls="sede-legale-panel"
                  role="tab"
                  data-toggle="collapse"
                  data-target="#sede-legale-panel"
                  href="#sede-legale-panel"
                  ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                    ><i class="fa-fusion-box"></i></span
                  ><span class="fusion-toggle-heading">Sede legale</span></a
                >
              </h4>
              <p
                class="section-completion-info"
                *ngIf="!isRegisteredOfficeValid()"
              >
                Non hai ancora compilato questa sezione
              </p>
            </div>
            <div
              id="sede-legale-panel"
              class="panel-collapse collapse in"
              style="height: auto"
            >
              <div class="panel-body toggle-content fusion-clearfix">
                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_3_4 fusion-builder-nested-column-1 fusion-three-fourth fusion-column-first 3_4"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 75%;
                      width: calc(75% - ((4%) * 0.75));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-1"
                      style="
                        padding: 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        background-size: cover;
                        height: auto;
                      "
                      data-bg-url=""
                    >
                      <div
                        class="fusion-builder-row fusion-builder-row-inner fusion-row"
                      >
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-3 fusion-one-half fusion-column-first 1_2"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 50%;
                            width: calc(50% - ((4%) * 0.5));
                            margin-right: 4%;
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-3"
                            style="
                              padding: 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              background-size: cover;
                              height: auto;
                            "
                            data-bg-url=""
                          >
                            <ul
                              class="fusion-checklist fusion-checklist-14"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <!-- <span
                                  style="
                                    height: 27.2px;
                                    width: 27.2px;
                                    margin-right: 11.2px;
                                  "
                                  class="icon-wrapper circle-no"
                                  ><i
                                    class="fusion-li-icon fa fa-city"
                                    style="color: #333333"
                                  ></i
                                ></span> -->
                                <div class="fusion-li-item-content">Città*</div>
                              </li>
                            </ul>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-16 .fusion-button-text,
                                .fusion-button.button-16 i {
                                  color: #333333;
                                }

                                .fusion-button.button-16
                                  .fusion-button-icon-divider {
                                  border-color: #333333;
                                }

                                .fusion-button.button-16:hover
                                  .fusion-button-text,
                                .fusion-button.button-16:hover i,
                                .fusion-button.button-16:focus
                                  .fusion-button-text,
                                .fusion-button.button-16:focus i,
                                .fusion-button.button-16:active
                                  .fusion-button-text,
                                .fusion-button.button-16:active {
                                  color: #ffffff;
                                }

                                .fusion-button.button-16:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-16:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-16:active
                                  .fusion-button-icon-divider {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-16:hover,
                                .fusion-button.button-16:focus,
                                .fusion-button.button-16:active {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-16 {
                                  border-color: #333333;
                                  border-radius: 0px;
                                }

                                .fusion-button.button-16 {
                                  background: #ffffff;
                                }

                                .fusion-button.button-16:hover,
                                .button-16:focus,
                                .fusion-button.button-16:active {
                                  background: #ffffff;
                                }
                              </style>
                              <input
                                placeholder="Inserisci città"
                                class="ng-app-input"
                                type="text"
                                formControlName="city"
                                (click)="resetError()"
                                required
                              />
                              <div
                                [ngStyle]="{
                                  visibility:
                                    profileForm.get('city').valid ||
                                    profileForm.get('city').pristine
                                      ? 'hidden'
                                      : 'visible'
                                }"
                                class="ng-alert"
                              >
                                La città è obbligatoria.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-4 fusion-one-half fusion-column-last 1_2"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 50%;
                            width: calc(50% - ((4%) * 0.5));
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-4"
                            style="
                              padding: 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              background-size: cover;
                              height: auto;
                            "
                            data-bg-url=""
                          >
                            <ul
                              class="fusion-checklist fusion-checklist-15"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <!-- <span
                                  style="
                                    height: 27.2px;
                                    width: 27.2px;
                                    margin-right: 11.2px;
                                  "
                                  class="icon-wrapper circle-no"
                                  ><i
                                    class="fusion-li-icon fa fa-city"
                                    style="color: #333333"
                                  ></i
                                ></span> -->
                                <div class="fusion-li-item-content">
                                  Provincia*
                                </div>
                              </li>
                            </ul>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-17 .fusion-button-text,
                                .fusion-button.button-17 i {
                                  color: #333333;
                                }

                                .fusion-button.button-17
                                  .fusion-button-icon-divider {
                                  border-color: #333333;
                                }

                                .fusion-button.button-17:hover
                                  .fusion-button-text,
                                .fusion-button.button-17:hover i,
                                .fusion-button.button-17:focus
                                  .fusion-button-text,
                                .fusion-button.button-17:focus i,
                                .fusion-button.button-17:active
                                  .fusion-button-text,
                                .fusion-button.button-17:active {
                                  color: #ffffff;
                                }

                                .fusion-button.button-17:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-17:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-17:active
                                  .fusion-button-icon-divider {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-17:hover,
                                .fusion-button.button-17:focus,
                                .fusion-button.button-17:active {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-17 {
                                  border-color: #333333;
                                  border-radius: 0px;
                                }

                                .fusion-button.button-17 {
                                  background: #ffffff;
                                }

                                .fusion-button.button-17:hover,
                                .button-17:focus,
                                .fusion-button.button-17:active {
                                  background: #ffffff;
                                }
                              </style>
                              <select
                                formControlName="provinceCode"
                                required
                                (click)="resetError()"
                              >
                                <option [ngValue]="null">
                                  Seleziona provincia
                                </option>
                                <option
                                  [ngValue]="province.code"
                                  *ngFor="let province of provinces"
                                >
                                  {{ province.description }}
                                </option>
                              </select>
                              <div
                                [ngStyle]="{
                                  visibility:
                                    profileForm.get('provinceCode').valid ||
                                    profileForm.get('provinceCode').pristine
                                      ? 'hidden'
                                      : 'visible'
                                }"
                                class="ng-alert"
                              >
                                La provincia è obbligatoria.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-2 fusion-one-fourth fusion-column-last 1_4"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 25%;
                      width: calc(25% - ((4%) * 0.25));
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-2"
                      style="
                        padding: 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        background-size: cover;
                        height: auto;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-16"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-city"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">CAP*</div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-18 .fusion-button-text,
                          .fusion-button.button-18 i {
                            color: #333333;
                          }

                          .fusion-button.button-18 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-18:hover .fusion-button-text,
                          .fusion-button.button-18:hover i,
                          .fusion-button.button-18:focus .fusion-button-text,
                          .fusion-button.button-18:focus i,
                          .fusion-button.button-18:active .fusion-button-text,
                          .fusion-button.button-18:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-18:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-18:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-18:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-18:hover,
                          .fusion-button.button-18:focus,
                          .fusion-button.button-18:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-18 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-18 {
                            background: #ffffff;
                          }

                          .fusion-button.button-18:hover,
                          .button-18:focus,
                          .fusion-button.button-18:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci CAP"
                          class="ng-app-input"
                          type="text"
                          formControlName="zipCode"
                          (click)="resetError()"
                          required
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('zipCode').valid ||
                              profileForm.get('zipCode').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Il CAP è obbligatorio.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-nested-column-25 fusion-two-third fusion-column-first 2_3"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 66.66%;
                      width: calc(66.66% - ((4%) * 0.6666));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-25"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-17"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-road"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">Indirizzo*</div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-19 .fusion-button-text,
                          .fusion-button.button-19 i {
                            color: #333333;
                          }

                          .fusion-button.button-19 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-19:hover .fusion-button-text,
                          .fusion-button.button-19:hover i,
                          .fusion-button.button-19:focus .fusion-button-text,
                          .fusion-button.button-19:focus i,
                          .fusion-button.button-19:active .fusion-button-text,
                          .fusion-button.button-19:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-19:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-19:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-19:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-19:hover,
                          .fusion-button.button-19:focus,
                          .fusion-button.button-19:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-19 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-19 {
                            background: #ffffff;
                          }

                          .fusion-button.button-19:hover,
                          .button-19:focus,
                          .fusion-button.button-19:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci indirizzo"
                          class="ng-app-input"
                          type="text"
                          formControlName="address"
                          (click)="resetError()"
                          required
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('address').valid ||
                              profileForm.get('address').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          L'indirizzo è obbligatorio.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-26 fusion-one-third fusion-column-last 1_3"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 33.33%;
                      width: calc(33.33% - ((4%) * 0.3333));
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-26"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-18"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-map-marked-alt"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">N° Civico*</div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-20 .fusion-button-text,
                          .fusion-button.button-20 i {
                            color: #333333;
                          }

                          .fusion-button.button-20 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-20:hover .fusion-button-text,
                          .fusion-button.button-20:hover i,
                          .fusion-button.button-20:focus .fusion-button-text,
                          .fusion-button.button-20:focus i,
                          .fusion-button.button-20:active .fusion-button-text,
                          .fusion-button.button-20:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-20:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-20:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-20:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-20:hover,
                          .fusion-button.button-20:focus,
                          .fusion-button.button-20:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-20 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-20 {
                            background: #ffffff;
                          }

                          .fusion-button.button-20:hover,
                          .button-20:focus,
                          .fusion-button.button-20:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci n. civico"
                          class="ng-app-input"
                          type="text"
                          formControlName="addressNumber"
                          (click)="resetError()"
                          required
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('addressNumber').valid ||
                              profileForm.get('addressNumber').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Il numero civico è obbligatorio.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SAVE BUTTON  -->

                <div class="fusion-sep-clear"></div>
                <div
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 20px;
                  "
                ></div>

                <!-- <div
                  [ngStyle]="{
                    visibility: error === 'no_error' ? 'hidden' : 'visible'
                  }"
                  class="ng-{{ errorMessageClass }}"
                >
                  {{ error }}
                </div> -->
                <div class="ng-spinner">
                  <img
                    *ngIf="loading"
                    src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
                  />
                </div>
                <div class="fusion-button-wrapper fusion-alignright">
                  <style type="text/css">
                    .fusion-button.button-35 {
                      border-radius: 0px;
                    }
                  </style>
                  <a
                    (click)="closeAccordion('sede-legale-link')"
                    appInvalidControlScroll
                    class="fusion-button button-flat button-large button-default button-35 fusion-button-default-span fusion-button-default-type"
                    target="_self"
                    ><span class="fusion-button-text">Conferma</span></a
                  >
                </div>

                <!-- SAVE BUTTON  -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <style type="text/css">
        #accordion-2089-5 .fusion-panel:hover,
        #accordion-2089-5 .fusion-panel.hover {
          background-color: #f9f9f9;
        }
        #accordion-2089-5 .fusion-panel {
          border-color: #d9d9d9;
          border-width: 1px;
          background-color: #ffffff;
        }
        .fusion-accordian #accordion-2089-5 .panel-title a .fa-fusion-box {
          color: #ffffff;
        }
        .fusion-accordian
          #accordion-2089-5
          .panel-title
          a
          .fa-fusion-box:before {
          font-size: 16px;
          width: 16px;
        }
        .fusion-accordian
          #accordion-2089-5.fusion-toggle-icon-right
          .fusion-toggle-heading {
          margin-right: 34px;
        }
        .fusion-accordian #accordion-2089-5 .panel-title a {
          font-size: 25px;
        }
        .fusion-accordian #accordion-2089-5 .fa-fusion-box {
          background-color: #6d6d6d;
          border-color: #6d6d6d;
        }
        .fusion-accordian #accordion-2089-5 .panel-title a:hover,
        #accordion-2089-5 .fusion-toggle-boxed-mode:hover .panel-title a {
          color: #ffa626;
        }
        .fusion-accordian #accordion-2089-5 .panel-title .active .fa-fusion-box,
        .fusion-accordian
          #accordion-2089-5
          .panel-title
          a:hover
          .fa-fusion-box {
          background-color: #ffa626 !important;
          border-color: #ffa626 !important;
        }
      </style> -->

      <div class="fusion-sep-clear"></div>
      <div
        *ngIf="!privateRegistry"
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>

      <!-- SEDE OPERATIVA  -->

      <div class="accordian fusion-accordian" *ngIf="!privateRegistry">
        <div
          class="panel-group fusion-toggle-icon-right"
          id="sede-operativa"
          role="tablist"
        >
          <div
            class="fusion-panel panel-default fusion-toggle-no-divider"
            role="tabpanel"
          >
            <div class="panel-heading">
              <h4
                class="panel-title toggle fusion-responsive-typography-calculated"
                data-fontsize="16"
                data-lineheight="22.08px"
                style="--fontSize: 16; line-height: 1.38; --minFontSize: 16"
              >
                <a
                  id="sede-operativa-link"
                  class="active"
                  aria-expanded="true"
                  aria-selected="true"
                  aria-controls="sede-operativa-panel"
                  role="tab"
                  data-toggle="collapse"
                  data-target="#sede-operativa-panel"
                  href="#sede-operativa-panel"
                  ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                    ><i class="fa-fusion-box"></i></span
                  ><span class="fusion-toggle-heading">Sede operativa</span></a
                >
              </h4>
              <p class="section-completion-info" *ngIf="!isHeadquarterValid()">
                Non hai ancora compilato questa sezione
              </p>
            </div>
            <div
              id="sede-operativa-panel"
              class="panel-collapse collapse in"
              style="height: auto"
            >
              <div class="panel-body toggle-content fusion-clearfix">
                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-nested-column-25 fusion-two-third fusion-column-first 2_3"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 66.66%;
                      width: calc(66.66% - ((4%) * 0.6666));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-25"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    ></div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-26 fusion-one-third fusion-column-last 1_3"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 33.33%;
                      width: calc(33.33% - ((4%) * 0.3333));
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-26"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-28 {
                            border-radius: 0px;
                          }
                        </style>
                        <a
                          (click)="copyLegalOfficeData()"
                          class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                          target="_self"
                          ><span class="fusion-button-text"
                            >Usa sede legale</span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="fusion-sep-clear"></div>
                <div
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 20px;
                  "
                ></div>
                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_3_4 fusion-builder-nested-column-1 fusion-three-fourth fusion-column-first 3_4"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 75%;
                      width: calc(75% - ((4%) * 0.75));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-1"
                      style="
                        padding: 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        background-size: cover;
                        height: auto;
                      "
                      data-bg-url=""
                    >
                      <div
                        class="fusion-builder-row fusion-builder-row-inner fusion-row"
                      >
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-3 fusion-one-half fusion-column-first 1_2"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 50%;
                            width: calc(50% - ((4%) * 0.5));
                            margin-right: 4%;
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-3"
                            style="
                              padding: 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              background-size: cover;
                              height: auto;
                            "
                            data-bg-url=""
                          >
                            <ul
                              class="fusion-checklist fusion-checklist-19"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <!-- <span
                                  style="
                                    height: 27.2px;
                                    width: 27.2px;
                                    margin-right: 11.2px;
                                  "
                                  class="icon-wrapper circle-no"
                                  ><i
                                    class="fusion-li-icon fa fa-city"
                                    style="color: #333333"
                                  ></i
                                ></span> -->
                                <div class="fusion-li-item-content">Città*</div>
                              </li>
                            </ul>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-21 .fusion-button-text,
                                .fusion-button.button-21 i {
                                  color: #333333;
                                }

                                .fusion-button.button-21
                                  .fusion-button-icon-divider {
                                  border-color: #333333;
                                }

                                .fusion-button.button-21:hover
                                  .fusion-button-text,
                                .fusion-button.button-21:hover i,
                                .fusion-button.button-21:focus
                                  .fusion-button-text,
                                .fusion-button.button-21:focus i,
                                .fusion-button.button-21:active
                                  .fusion-button-text,
                                .fusion-button.button-21:active {
                                  color: #ffffff;
                                }

                                .fusion-button.button-21:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-21:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-21:active
                                  .fusion-button-icon-divider {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-21:hover,
                                .fusion-button.button-21:focus,
                                .fusion-button.button-21:active {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-21 {
                                  border-color: #333333;
                                  border-radius: 0px;
                                }

                                .fusion-button.button-21 {
                                  background: #ffffff;
                                }

                                .fusion-button.button-21:hover,
                                .button-21:focus,
                                .fusion-button.button-21:active {
                                  background: #ffffff;
                                }
                              </style>
                              <input
                                placeholder="Inserisci città"
                                class="ng-app-input"
                                type="text"
                                formControlName="operationalCity"
                                (click)="resetError()"
                                required
                              />
                              <div
                                [ngStyle]="{
                                  visibility:
                                    profileForm.get('operationalCity').valid ||
                                    profileForm.get('operationalCity').pristine
                                      ? 'hidden'
                                      : 'visible'
                                }"
                                class="ng-alert"
                              >
                                La città è obbligatoria.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-4 fusion-one-half fusion-column-last 1_2"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 50%;
                            width: calc(50% - ((4%) * 0.5));
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-4"
                            style="
                              padding: 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              background-size: cover;
                              height: auto;
                            "
                            data-bg-url=""
                          >
                            <ul
                              class="fusion-checklist fusion-checklist-20"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <!-- <span
                                  style="
                                    height: 27.2px;
                                    width: 27.2px;
                                    margin-right: 11.2px;
                                  "
                                  class="icon-wrapper circle-no"
                                  ><i
                                    class="fusion-li-icon fa fa-city"
                                    style="color: #333333"
                                  ></i
                                ></span> -->
                                <div class="fusion-li-item-content">
                                  Provincia*
                                </div>
                              </li>
                            </ul>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-22 .fusion-button-text,
                                .fusion-button.button-22 i {
                                  color: #333333;
                                }

                                .fusion-button.button-22
                                  .fusion-button-icon-divider {
                                  border-color: #333333;
                                }

                                .fusion-button.button-22:hover
                                  .fusion-button-text,
                                .fusion-button.button-22:hover i,
                                .fusion-button.button-22:focus
                                  .fusion-button-text,
                                .fusion-button.button-22:focus i,
                                .fusion-button.button-22:active
                                  .fusion-button-text,
                                .fusion-button.button-22:active {
                                  color: #ffffff;
                                }

                                .fusion-button.button-22:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-22:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-22:active
                                  .fusion-button-icon-divider {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-22:hover,
                                .fusion-button.button-22:focus,
                                .fusion-button.button-22:active {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-22 {
                                  border-color: #333333;
                                  border-radius: 0px;
                                }

                                .fusion-button.button-22 {
                                  background: #ffffff;
                                }

                                .fusion-button.button-22:hover,
                                .button-22:focus,
                                .fusion-button.button-22:active {
                                  background: #ffffff;
                                }
                              </style>
                              <select
                                formControlName="operationalProvinceCode"
                                required
                                (click)="resetError()"
                              >
                                <option [ngValue]="null">
                                  Seleziona provincia
                                </option>
                                <option
                                  [ngValue]="province.code"
                                  *ngFor="let province of provinces"
                                >
                                  {{ province.description }}
                                </option>
                              </select>
                              <div
                                [ngStyle]="{
                                  visibility:
                                    profileForm.get('operationalProvinceCode')
                                      .valid ||
                                    profileForm.get('operationalProvinceCode')
                                      .pristine
                                      ? 'hidden'
                                      : 'visible'
                                }"
                                class="ng-alert"
                              >
                                La provincia è obbligatoria.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-2 fusion-one-fourth fusion-column-last 1_4"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 25%;
                      width: calc(25% - ((4%) * 0.25));
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-2"
                      style="
                        padding: 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        background-size: cover;
                        height: auto;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-21"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-city"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">CAP*</div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-23 .fusion-button-text,
                          .fusion-button.button-23 i {
                            color: #333333;
                          }

                          .fusion-button.button-23 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-23:hover .fusion-button-text,
                          .fusion-button.button-23:hover i,
                          .fusion-button.button-23:focus .fusion-button-text,
                          .fusion-button.button-23:focus i,
                          .fusion-button.button-23:active .fusion-button-text,
                          .fusion-button.button-23:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-23:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-23:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-23:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-23:hover,
                          .fusion-button.button-23:focus,
                          .fusion-button.button-23:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-23 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-23 {
                            background: #ffffff;
                          }

                          .fusion-button.button-23:hover,
                          .button-23:focus,
                          .fusion-button.button-23:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci CAP"
                          class="ng-app-input"
                          type="text"
                          formControlName="operationalZipCode"
                          (click)="resetError()"
                          required
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('operationalZipCode').valid ||
                              profileForm.get('operationalZipCode').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Il CAP è obbligatorio.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-27 fusion-one-half fusion-column-first 1_2"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 50%;
                      width: calc(50% - ((4% + 4%) * 0.5));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-27"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-28 fusion-one-fourth 1_4"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 25%;
                      width: calc(25% - ((4% + 4%) * 0.25));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-28"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-29 fusion-one-fourth fusion-column-last 1_4"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 25%;
                      width: calc(25% - ((4% + 4%) * 0.25));
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-29"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      
                    </div>
                  </div>
                </div> -->
                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-nested-column-30 fusion-two-third fusion-column-first 2_3"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 66.66%;
                      width: calc(66.66% - ((4%) * 0.6666));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-30"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-22"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-road"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">Indirizzo*</div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-24 .fusion-button-text,
                          .fusion-button.button-24 i {
                            color: #333333;
                          }

                          .fusion-button.button-24 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-24:hover .fusion-button-text,
                          .fusion-button.button-24:hover i,
                          .fusion-button.button-24:focus .fusion-button-text,
                          .fusion-button.button-24:focus i,
                          .fusion-button.button-24:active .fusion-button-text,
                          .fusion-button.button-24:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-24:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-24:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-24:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-24:hover,
                          .fusion-button.button-24:focus,
                          .fusion-button.button-24:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-24 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-24 {
                            background: #ffffff;
                          }

                          .fusion-button.button-24:hover,
                          .button-24:focus,
                          .fusion-button.button-24:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci indirizzo"
                          class="ng-app-input"
                          type="text"
                          formControlName="operationalAddress"
                          (click)="resetError()"
                          required
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('operationalAddress').valid ||
                              profileForm.get('operationalAddress').pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          L'indirizzo è obbligatorio.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-31 fusion-one-third fusion-column-last 1_3"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 33.33%;
                      width: calc(33.33% - ((4%) * 0.3333));
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-31"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <ul
                        class="fusion-checklist fusion-checklist-23"
                        style="font-size: 16px; line-height: 27.2px"
                      >
                        <li class="fusion-li-item">
                          <!-- <span
                            style="
                              height: 27.2px;
                              width: 27.2px;
                              margin-right: 11.2px;
                            "
                            class="icon-wrapper circle-no"
                            ><i
                              class="fusion-li-icon fa fa-map-marked-alt"
                              style="color: #333333"
                            ></i
                          ></span> -->
                          <div class="fusion-li-item-content">N° Civico*</div>
                        </li>
                      </ul>
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-25 .fusion-button-text,
                          .fusion-button.button-25 i {
                            color: #333333;
                          }

                          .fusion-button.button-25 .fusion-button-icon-divider {
                            border-color: #333333;
                          }

                          .fusion-button.button-25:hover .fusion-button-text,
                          .fusion-button.button-25:hover i,
                          .fusion-button.button-25:focus .fusion-button-text,
                          .fusion-button.button-25:focus i,
                          .fusion-button.button-25:active .fusion-button-text,
                          .fusion-button.button-25:active {
                            color: #ffffff;
                          }

                          .fusion-button.button-25:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-25:hover
                            .fusion-button-icon-divider,
                          .fusion-button.button-25:active
                            .fusion-button-icon-divider {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-25:hover,
                          .fusion-button.button-25:focus,
                          .fusion-button.button-25:active {
                            border-color: #ffffff;
                          }

                          .fusion-button.button-25 {
                            border-color: #333333;
                            border-radius: 0px;
                          }

                          .fusion-button.button-25 {
                            background: #ffffff;
                          }

                          .fusion-button.button-25:hover,
                          .button-25:focus,
                          .fusion-button.button-25:active {
                            background: #ffffff;
                          }
                        </style>
                        <input
                          placeholder="Inserisci n. civico"
                          class="ng-app-input"
                          type="text"
                          formControlName="operationalAddressNumber"
                          (click)="resetError()"
                          required
                        />
                        <div
                          [ngStyle]="{
                            visibility:
                              profileForm.get('operationalAddressNumber')
                                .valid ||
                              profileForm.get('operationalAddressNumber')
                                .pristine
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-alert"
                        >
                          Il numero civico è obbligatorio.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SAVE BUTTON  -->
                <div class="fusion-sep-clear"></div>
                <div
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 20px;
                  "
                ></div>

                <!-- <div
                  [ngStyle]="{
                    visibility: error === 'no_error' ? 'hidden' : 'visible'
                  }"
                  class="ng-{{ errorMessageClass }}"
                >
                  {{ error }}
                </div> -->
                <div class="ng-spinner">
                  <img
                    *ngIf="loading"
                    src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
                  />
                </div>
                <div class="fusion-button-wrapper fusion-alignright">
                  <style type="text/css">
                    .fusion-button.button-35 {
                      border-radius: 0px;
                    }
                  </style>
                  <a
                    (click)="closeAccordion('sede-operativa-link')"
                    appInvalidControlScroll
                    class="fusion-button button-flat button-large button-default button-35 fusion-button-default-span fusion-button-default-type"
                    target="_self"
                    ><span class="fusion-button-text">Conferma</span></a
                  >
                </div>

                <!-- SAVE BUTTON  -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <style type="text/css">
        #accordion-2089-6 .fusion-panel:hover,
        #accordion-2089-6 .fusion-panel.hover {
          background-color: #f9f9f9;
        }
        #accordion-2089-6 .fusion-panel {
          border-color: #d9d9d9;
          border-width: 1px;
          background-color: #ffffff;
        }
        .fusion-accordian #accordion-2089-6 .panel-title a .fa-fusion-box {
          color: #ffffff;
        }
        .fusion-accordian
          #accordion-2089-6
          .panel-title
          a
          .fa-fusion-box:before {
          font-size: 16px;
          width: 16px;
        }
        .fusion-accordian
          #accordion-2089-6.fusion-toggle-icon-right
          .fusion-toggle-heading {
          margin-right: 34px;
        }
        .fusion-accordian #accordion-2089-6 .panel-title a {
          font-size: 25px;
        }
        .fusion-accordian #accordion-2089-6 .fa-fusion-box {
          background-color: #6d6d6d;
          border-color: #6d6d6d;
        }
        .fusion-accordian #accordion-2089-6 .panel-title a:hover,
        #accordion-2089-6 .fusion-toggle-boxed-mode:hover .panel-title a {
          color: #ffa626;
        }
        .fusion-accordian #accordion-2089-6 .panel-title .active .fa-fusion-box,
        .fusion-accordian
          #accordion-2089-6
          .panel-title
          a:hover
          .fa-fusion-box {
          background-color: #ffa626 !important;
          border-color: #ffa626 !important;
        }
      </style> -->

      <div class="fusion-sep-clear"></div>
      <div
        *ngIf="!privateRegistry"
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>

      <!-- ALLEGATI  -->

      <div class="accordian fusion-accordian" *ngIf="!privateRegistry">
        <div
          class="panel-group fusion-toggle-icon-right"
          id="allegati-panel"
          role="tablist"
        >
          <div
            class="fusion-panel panel-default fusion-toggle-no-divider fusion-toggle-boxed-mode"
            role="tabpanel"
          >
            <div class="panel-heading">
              <h4
                class="panel-title toggle fusion-responsive-typography-calculated"
                data-fontsize="16"
                data-lineheight="22.08px"
                style="--fontSize: 16; line-height: 1.38; --minFontSize: 16"
              >
                <a
                  id="allegati-link"
                  class="active"
                  aria-expanded="true"
                  aria-selected="true"
                  aria-controls="allegati-accordion"
                  role="tab"
                  data-toggle="collapse"
                  data-parent="#allegati-panel"
                  data-target="#allegati-accordion"
                  href="#allegati-accordion"
                  ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                    ><i class="fa-fusion-box"></i></span
                  ><span class="fusion-toggle-heading">Allegati</span></a
                >
              </h4>
              <p class="section-completion-info" *ngIf="!areAttachmentsValid()">
                Non hai ancora compilato questa sezione
              </p>
            </div>
            <div id="allegati-accordion" class="panel-collapse collapse in">
              <div class="panel-body toggle-content fusion-clearfix">
                <div
                  class="fusion-builder-row fusion-builder-row-inner fusion-row"
                >
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-32 fusion-one-third fusion-column-first 1_3"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 33.33%;
                      width: calc(33.33% - ((4% + 4%) * 0.3333));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-32"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-26 {
                            border-radius: 0px;
                          }
                        </style>
                        <input
                          style="display: none"
                          type="file"
                          (change)="uploadLogo($event)"
                          #uploadLogoInput
                        />
                        <a
                          (click)="uploadLogoInput.click()"
                          class="fusion-button button-flat fusion-button-default-size button-default button-26 fusion-button-span-yes fusion-button-default-type"
                          target="_self"
                          ><span class="fusion-button-text"
                            >Carica Logo</span
                          ></a
                        >
                      </div>

                      <div
                        class="fusion-separator fusion-full-width-sep sep-none"
                        style="
                          margin-left: auto;
                          margin-right: auto;
                          margin-top: 15px;
                        "
                      ></div>

                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-26 {
                            border-radius: 0px;
                          }
                        </style>
                        <a
                          (click)="goToLogoUrl()"
                          class="ng-dark-button{{
                            logo.buttonClass
                          }} fusion-button button-flat fusion-button-default-size button-default button-26 fusion-button-span-yes fusion-button-default-type"
                          target="_blank"
                          ><span class="fusion-button-text"
                            >Scarica Logo</span
                          ></a
                        >
                        <div
                          [ngStyle]="{
                            visibility:
                              logo.message === 'no_message'
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-info"
                        >
                          {{ logo.message }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-33 fusion-one-third 1_3"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 33.33%;
                      width: calc(33.33% - ((4% + 4%) * 0.3333));
                      margin-right: 4%;
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-33"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-27 {
                            border-radius: 0px;
                          }
                        </style>
                        <input
                          style="display: none"
                          type="file"
                          (change)="uploadVisura($event)"
                          #uploadVisuraInput
                        />
                        <a
                          (click)="uploadVisuraInput.click()"
                          class="fusion-button button-flat fusion-button-default-size button-default button-27 fusion-button-span-yes fusion-button-default-type"
                          target="_self"
                          ><span class="fusion-button-text"
                            >Carica Visura</span
                          ></a
                        >
                      </div>

                      <div
                        class="fusion-separator fusion-full-width-sep sep-none"
                        style="
                          margin-left: auto;
                          margin-right: auto;
                          margin-top: 15px;
                        "
                      ></div>

                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-26 {
                            border-radius: 0px;
                          }
                        </style>
                        <a
                          (click)="goToVisuraUrl()"
                          class="ng-dark-button{{
                            visura.buttonClass
                          }} fusion-button button-flat fusion-button-default-size button-default button-26 fusion-button-span-yes fusion-button-default-type"
                          target="_blank"
                          ><span class="fusion-button-text"
                            >Scarica Visura</span
                          ></a
                        >
                        <div
                          [ngStyle]="{
                            visibility:
                              visura.message === 'no_message'
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-info"
                        >
                          {{ visura.message }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-34 fusion-one-third fusion-column-last 1_3"
                    style="
                      margin-top: 0px;
                      margin-bottom: 0px;
                      width: 33.33%;
                      width: calc(33.33% - ((4% + 4%) * 0.3333));
                    "
                  >
                    <div
                      class="fusion-column-wrapper fusion-column-wrapper-34"
                      style="
                        padding: 0px 0px 0px 0px;
                        background-position: left top;
                        background-repeat: no-repeat;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                      "
                      data-bg-url=""
                    >
                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-28 {
                            border-radius: 0px;
                          }
                        </style>
                        <input
                          style="display: none"
                          type="file"
                          (change)="uploadDurc($event)"
                          #uploadDurcInput
                        />
                        <a
                          (click)="uploadDurcInput.click()"
                          class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                          target="_self"
                          ><span class="fusion-button-text"
                            >Carica DURC</span
                          ></a
                        >
                      </div>

                      <div
                        class="fusion-separator fusion-full-width-sep sep-none"
                        style="
                          margin-left: auto;
                          margin-right: auto;
                          margin-top: 15px;
                        "
                      ></div>

                      <div class="fusion-button-wrapper fusion-align-block">
                        <style type="text/css">
                          .fusion-button.button-26 {
                            border-radius: 0px;
                          }
                        </style>
                        <a
                          (click)="goToDurcUrl()"
                          class="ng-dark-button{{
                            durc.buttonClass
                          }} fusion-button button-flat fusion-button-default-size button-default button-26 fusion-button-span-yes fusion-button-default-type"
                          target="_blank"
                          ><span class="fusion-button-text"
                            >Scarica DURC</span
                          ></a
                        >
                        <div
                          [ngStyle]="{
                            visibility:
                              durc.message === 'no_message'
                                ? 'hidden'
                                : 'visible'
                          }"
                          class="ng-info"
                        >
                          {{ durc.message }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SAVE BUTTON  -->
                <div class="fusion-sep-clear"></div>
                <div
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 20px;
                  "
                ></div>

                <!-- <div
                  [ngStyle]="{
                    visibility: error === 'no_error' ? 'hidden' : 'visible'
                  }"
                  class="ng-{{ errorMessageClass }}"
                >
                  {{ error }}
                </div> -->
                <div class="ng-spinner">
                  <img
                    *ngIf="loading"
                    src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
                  />
                </div>
                <div class="fusion-button-wrapper fusion-alignright">
                  <style type="text/css">
                    .fusion-button.button-35 {
                      border-radius: 0px;
                    }
                  </style>
                  <a
                    (click)="closeAccordion('allegati-link')"
                    appInvalidControlScroll
                    class="fusion-button button-flat button-large button-default button-35 fusion-button-default-span fusion-button-default-type"
                    target="_self"
                    ><span class="fusion-button-text">Conferma</span></a
                  >
                </div>

                <!-- SAVE BUTTON  -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <style type="text/css">
        #accordion-2089-7 .fusion-panel:hover,
        #accordion-2089-7 .fusion-panel.hover {
          background-color: #f9f9f9;
        }
        #accordion-2089-7 .fusion-panel {
          border-color: #d9d9d9;
          border-width: 1px;
          background-color: #ffffff;
        }
        .fusion-accordian #accordion-2089-7 .panel-title a .fa-fusion-box {
          color: #ffffff;
        }
        .fusion-accordian
          #accordion-2089-7
          .panel-title
          a
          .fa-fusion-box:before {
          font-size: 16px;
          width: 16px;
        }
        .fusion-accordian
          #accordion-2089-7.fusion-toggle-icon-right
          .fusion-toggle-heading {
          margin-right: 34px;
        }
        .fusion-accordian #accordion-2089-7 .panel-title a {
          font-size: 25px;
        }
        .fusion-accordian #accordion-2089-7 .fa-fusion-box {
          background-color: #6d6d6d;
          border-color: #6d6d6d;
        }
        .fusion-accordian #accordion-2089-7 .panel-title a:hover,
        #accordion-2089-7 .fusion-toggle-boxed-mode:hover .panel-title a {
          color: #ffa626;
        }
        .fusion-accordian #accordion-2089-7 .panel-title .active .fa-fusion-box,
        .fusion-accordian
          #accordion-2089-7
          .panel-title
          a:hover
          .fa-fusion-box {
          background-color: #ffa626 !important;
          border-color: #ffa626 !important;
        }
      </style> -->

      <div class="fusion-sep-clear"></div>
      <div
        *ngIf="!privateRegistry"
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>

      <!-- CERTIFICAZIONI ACCORDION  -->

      <div class="accordian fusion-accordian" *ngIf="!privateRegistry">
        <div
          class="panel-group fusion-toggle-icon-right"
          id="certificazioni"
          role="tablist"
        >
          <div
            class="fusion-panel panel-default fusion-toggle-no-divider"
            role="tabpanel"
          >
            <div class="panel-heading">
              <h4
                class="panel-title toggle fusion-responsive-typography-calculated"
                data-fontsize="16"
                data-lineheight="22.08px"
                style="--fontSize: 16; line-height: 1.38; --minFontSize: 16"
              >
                <a
                  id="certificazioni-link"
                  class="active"
                  aria-expanded="true"
                  aria-selected="true"
                  aria-controls="certificazioni-panel"
                  role="tab"
                  data-toggle="collapse"
                  data-target="#certificazioni-panel"
                  href="#certificazioni-panel"
                  ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                    ><i class="fa-fusion-box"></i></span
                  ><span class="fusion-toggle-heading">Certificazioni</span></a
                >
                <p
                  class="section-completion-info"
                  *ngIf="!areCertificationsValid()"
                >
                  Non hai ancora compilato questa sezione
                </p>
              </h4>
            </div>
            <div
              id="certificazioni-panel"
              class="panel-collapse collapse in"
              style="height: auto"
            >
              <div class="panel-body toggle-content fusion-clearfix">
                <div
                  class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-nested-column-25 fusion-two-third fusion-column-first 2_3"
                  style="
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width: 66.66%;
                    width: calc(66.66% - ((4%) * 0.6666));
                    margin-right: 4%;
                  "
                >
                  <div
                    class="fusion-column-wrapper fusion-column-wrapper-25"
                    style="
                      padding: 0px 0px 0px 0px;
                      background-position: left top;
                      background-repeat: no-repeat;
                      -webkit-background-size: cover;
                      -moz-background-size: cover;
                      -o-background-size: cover;
                      background-size: cover;
                    "
                    data-bg-url=""
                  ></div>
                </div>
                <div
                  class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-26 fusion-one-third fusion-column-last 1_3"
                  style="
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width: 33.33%;
                    width: calc(33.33% - ((4%) * 0.3333));
                  "
                >
                  <div
                    class="fusion-column-wrapper fusion-column-wrapper-26"
                    style="
                      padding: 0px 0px 0px 0px;
                      background-position: left top;
                      background-repeat: no-repeat;
                      -webkit-background-size: cover;
                      -moz-background-size: cover;
                      -o-background-size: cover;
                      background-size: cover;
                    "
                    data-bg-url=""
                  >
                    <div class="fusion-button-wrapper fusion-align-block">
                      <style type="text/css">
                        .fusion-button.button-28 {
                          border-radius: 0px;
                        }
                      </style>
                      <a
                        (click)="addCertification()"
                        class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                        target="_self"
                        ><span class="fusion-button-text">Aggiungi</span></a
                      >
                    </div>
                  </div>
                </div>
                <div class="fusion-sep-clear"></div>
                <div
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 10px;
                  "
                ></div>

                <div *ngFor="let certification of certifications">
                  <div
                    class="fusion-separator fusion-full-width-sep sep-none"
                    style="
                      margin-left: auto;
                      margin-right: auto;
                      margin-top: 15px;
                    "
                  ></div>
                  <div
                    class="specialization-container"
                    style="display: flex; flex-wrap: wrap"
                  >
                    <div
                      class="fusion-builder-row fusion-builder-row-inner fusion-row"
                    >
                      <div
                        class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-11 fusion-one-half fusion-column-first 1_2"
                        style="
                          margin-top: 0px;
                          margin-bottom: 0px;
                          width: 50%;
                          width: calc(50% - ((4%) * 0.5));
                          margin-right: 4%;
                        "
                      >
                        <div
                          class="fusion-column-wrapper fusion-column-wrapper-11"
                          style="
                            padding: 0px 0px 0px 0px;
                            background-position: left top;
                            background-repeat: no-repeat;
                            -webkit-background-size: cover;
                            -moz-background-size: cover;
                            -o-background-size: cover;
                            background-size: cover;
                          "
                          data-bg-url=""
                        >
                          <ul
                            class="fusion-checklist fusion-checklist-15"
                            style="font-size: 16px; line-height: 27.2px"
                          >
                            <li class="fusion-li-item">
                              <div class="fusion-li-item-content">
                                Certificazione
                              </div>
                            </li>
                          </ul>
                          <div class="fusion-button-wrapper fusion-align-block">
                            <style type="text/css">
                              .fusion-button.button-17 .fusion-button-text,
                              .fusion-button.button-17 i {
                                color: #333333;
                              }

                              .fusion-button.button-17
                                .fusion-button-icon-divider {
                                border-color: #333333;
                              }

                              .fusion-button.button-17:hover
                                .fusion-button-text,
                              .fusion-button.button-17:hover i,
                              .fusion-button.button-17:focus
                                .fusion-button-text,
                              .fusion-button.button-17:focus i,
                              .fusion-button.button-17:active
                                .fusion-button-text,
                              .fusion-button.button-17:active {
                                color: #ffffff;
                              }

                              .fusion-button.button-17:hover
                                .fusion-button-icon-divider,
                              .fusion-button.button-17:hover
                                .fusion-button-icon-divider,
                              .fusion-button.button-17:active
                                .fusion-button-icon-divider {
                                border-color: #ffffff;
                              }

                              .fusion-button.button-17:hover,
                              .fusion-button.button-17:focus,
                              .fusion-button.button-17:active {
                                border-color: #ffffff;
                              }

                              .fusion-button.button-17 {
                                border-color: #333333;
                                border-radius: 0px;
                              }

                              .fusion-button.button-17 {
                                background: #ffffff;
                              }

                              .fusion-button.button-17:hover,
                              .button-17:focus,
                              .fusion-button.button-17:active {
                                background: #ffffff;
                              }
                            </style>
                            <input
                              placeholder="Inserisci certificazione"
                              class="manual-validation-valid"
                              class="ng-app-input"
                              type="text"
                              [(ngModel)]="certification.certification.name"
                              [ngModelOptions]="{ standalone: true }"
                              (ngModelChange)="setCertif(certification)"
                            />
                          </div>
                        </div>
                      </div>
                      <style>
                        a {
                          color: #333333;
                        }
                        a:hover {
                          color: var(--ng-app-theme-yellow-color);
                        }
                      </style>
                      <div
                        class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-24 fusion-one-fourth fusion-column-last 1_4"
                        style="
                          margin-top: 0px;
                          margin-bottom: 0px;
                          width: 23%;
                          width: calc(23% - ((4% + 4%) * 0.25));
                        "
                      >
                        <div
                          class="fusion-column-wrapper fusion-column-wrapper-24"
                          style="
                            padding: 0px 0px 0px 0px;
                            background-position: left top;
                            background-repeat: no-repeat;
                            -webkit-background-size: cover;
                            -moz-background-size: cover;
                            -o-background-size: cover;
                            background-size: cover;
                          "
                          data-bg-url=""
                        >
                          <div
                            class="fusion-separator fusion-full-width-sep sep-none"
                            style="
                              margin-left: auto;
                              margin-right: auto;
                              margin-top: 40px;
                            "
                          ></div>
                          <div class="fusion-button-wrapper fusion-align-block">
                            <style type="text/css">
                              .fusion-button.button-28 {
                                border-radius: 0px;
                              }
                            </style>
                            <a
                              (click)="removeCertification(certification)"
                              class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                              target="_self"
                              ><span class="fusion-button-text"
                                >Rimuovi</span
                              ></a
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        class="fusion-separator fusion-full-width-sep sep-none"
                        style="
                          margin-left: auto;
                          margin-right: auto;
                          margin-top: 15px;
                        "
                      ></div>
                      <div
                        *ngIf="
                          certification.errorMessage !== null &&
                          certification.errorMessage != undefined
                        "
                        class="ng-alert"
                      >
                        {{ certification.errorMessage }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SAVE BUTTON  -->
                <div class="fusion-sep-clear"></div>
                <div
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 20px;
                  "
                ></div>

                <!-- <div
                  [ngStyle]="{
                    visibility: error === 'no_error' ? 'hidden' : 'visible'
                  }"
                  class="ng-{{ errorMessageClass }}"
                >
                  {{ error }}
                </div> -->
                <div class="ng-spinner">
                  <img
                    *ngIf="loading"
                    src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
                  />
                </div>
                <div class="fusion-button-wrapper fusion-alignright">
                  <style type="text/css">
                    .fusion-button.button-35 {
                      border-radius: 0px;
                    }
                  </style>
                  <a
                    (click)="closeAccordion('certificazioni-link')"
                    appInvalidControlScroll
                    class="fusion-button button-flat button-large button-default button-35 fusion-button-default-span fusion-button-default-type"
                    target="_self"
                    ><span class="fusion-button-text">Conferma</span></a
                  >
                </div>

                <!-- SAVE BUTTON  -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        *ngIf="!privateRegistry"
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>

      <!-- ATTESTATI ACCORDION -->

      <div class="accordian fusion-accordian" *ngIf="!privateRegistry">
        <div
          class="panel-group fusion-toggle-icon-right"
          id="attestati"
          role="tablist"
        >
          <div
            class="fusion-panel panel-default fusion-toggle-no-divider"
            role="tabpanel"
          >
            <div class="panel-heading">
              <h4
                class="panel-title toggle fusion-responsive-typography-calculated"
                data-fontsize="16"
                data-lineheight="22.08px"
                style="--fontSize: 16; line-height: 1.38; --minFontSize: 16"
              >
                <a
                  id="attestati-link"
                  class="active"
                  aria-expanded="true"
                  aria-selected="true"
                  aria-controls="attestati-panel"
                  role="tab"
                  data-toggle="collapse"
                  data-target="#attestati-panel"
                  href="#attestati-panel"
                  ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                    ><i class="fa-fusion-box"></i></span
                  ><span class="fusion-toggle-heading">Attestati</span></a
                >
                <p
                  class="section-completion-info"
                  *ngIf="!areCertificatesValid()"
                >
                  Non hai ancora compilato questa sezione
                </p>
              </h4>
            </div>
            <div
              id="attestati-panel"
              class="panel-collapse collapse in"
              style="height: auto"
            >
              <div class="panel-body toggle-content fusion-clearfix">
                <div
                  class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-nested-column-25 fusion-two-third fusion-column-first 2_3"
                  style="
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width: 66.66%;
                    width: calc(66.66% - ((4%) * 0.6666));
                    margin-right: 4%;
                  "
                >
                  <div
                    class="fusion-column-wrapper fusion-column-wrapper-25"
                    style="
                      padding: 0px 0px 0px 0px;
                      background-position: left top;
                      background-repeat: no-repeat;
                      -webkit-background-size: cover;
                      -moz-background-size: cover;
                      -o-background-size: cover;
                      background-size: cover;
                    "
                    data-bg-url=""
                  ></div>
                </div>
                <div
                  class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-26 fusion-one-third fusion-column-last 1_3"
                  style="
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width: 33.33%;
                    width: calc(33.33% - ((4%) * 0.3333));
                  "
                >
                  <div
                    class="fusion-column-wrapper fusion-column-wrapper-26"
                    style="
                      padding: 0px 0px 0px 0px;
                      background-position: left top;
                      background-repeat: no-repeat;
                      -webkit-background-size: cover;
                      -moz-background-size: cover;
                      -o-background-size: cover;
                      background-size: cover;
                    "
                    data-bg-url=""
                  >
                    <div class="fusion-button-wrapper fusion-align-block">
                      <style type="text/css">
                        .fusion-button.button-28 {
                          border-radius: 0px;
                        }
                      </style>
                      <a
                        (click)="addCertificate()"
                        class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                        target="_self"
                        ><span class="fusion-button-text">Aggiungi</span></a
                      >
                    </div>
                  </div>
                </div>

                <div class="fusion-sep-clear"></div>
                <div
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 10px;
                  "
                ></div>

                <div *ngFor="let certificate of certificates">
                  <div
                    class="fusion-separator fusion-full-width-sep sep-none"
                    style="
                      margin-left: auto;
                      margin-right: auto;
                      margin-top: 15px;
                    "
                  ></div>
                  <div
                    class="specialization-container"
                    style="display: flex; flex-wrap: wrap"
                  >
                    <div
                      class="fusion-builder-row fusion-builder-row-inner fusion-row"
                    >
                      <div
                        class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-11 fusion-one-half fusion-column-first 1_2"
                        style="
                          margin-top: 0px;
                          margin-bottom: 0px;
                          width: 50%;
                          width: calc(50% - ((4%) * 0.5));
                          margin-right: 4%;
                        "
                      >
                        <div
                          class="fusion-column-wrapper fusion-column-wrapper-11"
                          style="
                            padding: 0px 0px 0px 0px;
                            background-position: left top;
                            background-repeat: no-repeat;
                            -webkit-background-size: cover;
                            -moz-background-size: cover;
                            -o-background-size: cover;
                            background-size: cover;
                          "
                          data-bg-url=""
                        >
                          <ul
                            class="fusion-checklist fusion-checklist-15"
                            style="font-size: 16px; line-height: 27.2px"
                          >
                            <li class="fusion-li-item">
                              <div class="fusion-li-item-content">
                                Attestato
                              </div>
                            </li>
                          </ul>
                          <div class="fusion-button-wrapper fusion-align-block">
                            <style type="text/css">
                              .fusion-button.button-17 .fusion-button-text,
                              .fusion-button.button-17 i {
                                color: #333333;
                              }

                              .fusion-button.button-17
                                .fusion-button-icon-divider {
                                border-color: #333333;
                              }

                              .fusion-button.button-17:hover
                                .fusion-button-text,
                              .fusion-button.button-17:hover i,
                              .fusion-button.button-17:focus
                                .fusion-button-text,
                              .fusion-button.button-17:focus i,
                              .fusion-button.button-17:active
                                .fusion-button-text,
                              .fusion-button.button-17:active {
                                color: #ffffff;
                              }

                              .fusion-button.button-17:hover
                                .fusion-button-icon-divider,
                              .fusion-button.button-17:hover
                                .fusion-button-icon-divider,
                              .fusion-button.button-17:active
                                .fusion-button-icon-divider {
                                border-color: #ffffff;
                              }

                              .fusion-button.button-17:hover,
                              .fusion-button.button-17:focus,
                              .fusion-button.button-17:active {
                                border-color: #ffffff;
                              }

                              .fusion-button.button-17 {
                                border-color: #333333;
                                border-radius: 0px;
                              }

                              .fusion-button.button-17 {
                                background: #ffffff;
                              }

                              .fusion-button.button-17:hover,
                              .button-17:focus,
                              .fusion-button.button-17:active {
                                background: #ffffff;
                              }
                            </style>
                            <input
                              placeholder="Inserisci attestato"
                              class="manual-validation-valid"
                              class="ng-app-input"
                              type="text"
                              [(ngModel)]="certificate.certificate.name"
                              [ngModelOptions]="{ standalone: true }"
                              (ngModelChange)="setCertificatesItem(certificate)"
                            />
                          </div>
                        </div>
                      </div>
                      <style>
                        a {
                          color: #333333;
                        }
                        a:hover {
                          color: var(--ng-app-theme-yellow-color);
                        }
                      </style>
                      <div
                        class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-24 fusion-one-fourth fusion-column-last 1_4"
                        style="
                          margin-top: 0px;
                          margin-bottom: 0px;
                          width: 23%;
                          width: calc(23% - ((4% + 4%) * 0.25));
                        "
                      >
                        <div
                          class="fusion-column-wrapper fusion-column-wrapper-24"
                          style="
                            padding: 0px 0px 0px 0px;
                            background-position: left top;
                            background-repeat: no-repeat;
                            -webkit-background-size: cover;
                            -moz-background-size: cover;
                            -o-background-size: cover;
                            background-size: cover;
                          "
                          data-bg-url=""
                        >
                          <div
                            class="fusion-separator fusion-full-width-sep sep-none"
                            style="
                              margin-left: auto;
                              margin-right: auto;
                              margin-top: 40px;
                            "
                          ></div>
                          <div class="fusion-button-wrapper fusion-align-block">
                            <style type="text/css">
                              .fusion-button.button-28 {
                                border-radius: 0px;
                              }
                            </style>
                            <a
                              (click)="removeCertificate(certificate)"
                              class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                              target="_self"
                              ><span class="fusion-button-text"
                                >Rimuovi</span
                              ></a
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        class="fusion-separator fusion-full-width-sep sep-none"
                        style="
                          margin-left: auto;
                          margin-right: auto;
                          margin-top: 15px;
                        "
                      ></div>
                      <div
                        *ngIf="
                          certificate.errorMessage !== null &&
                          certificate.errorMessage != undefined
                        "
                        class="ng-alert"
                      >
                        {{ certificate.errorMessage }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- SAVE BUTTON  -->
                <div class="fusion-sep-clear"></div>
                <div
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 20px;
                  "
                ></div>

                <!-- <div
                  [ngStyle]="{
                    visibility: error === 'no_error' ? 'hidden' : 'visible'
                  }"
                  class="ng-{{ errorMessageClass }}"
                >
                  {{ error }}
                </div> -->
                <div class="ng-spinner">
                  <img
                    *ngIf="loading"
                    src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
                  />
                </div>
                <div class="fusion-button-wrapper fusion-alignright">
                  <style type="text/css">
                    .fusion-button.button-35 {
                      border-radius: 0px;
                    }
                  </style>
                  <a
                    (click)="closeAccordion('attestati-link')"
                    appInvalidControlScroll
                    class="fusion-button button-flat button-large button-default button-35 fusion-button-default-span fusion-button-default-type"
                    target="_self"
                    ><span class="fusion-button-text">Conferma</span></a
                  >
                </div>

                <!-- SAVE BUTTON  -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CERTIFICAZIONI ATTESTATI E REFERENZE  -->

      <!-- <div class="accordian fusion-accordian">
        <div
          class="panel-group fusion-toggle-icon-right"
          id="accordion-2089-7"
          role="tablist"
        >
          <div
            class="fusion-panel panel-default fusion-toggle-no-divider fusion-toggle-boxed-mode"
            role="tabpanel"
          >
            <div class="panel-heading">
              <h4
                class="panel-title toggle fusion-responsive-typography-calculated"
                data-fontsize="16"
                data-lineheight="22.08px"
                style="--fontSize: 16; line-height: 1.38; --minFontSize: 16"
              >
                <a
                  class="active"
                  aria-expanded="true"
                  aria-selected="true"
                  aria-controls="62e9f2f2b9e688400"
                  role="tab"
                  data-toggle="collapse"
                  data-parent="#accordion-2089-7"
                  data-target="#62e9f2f2b9e688400"
                  href="#62e9f2f2b9e688400"
                  ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                    ><i class="fa-fusion-box"></i></span
                  ><span class="fusion-toggle-heading"
                    >Certificazioni, attestati e referenze</span
                  ></a
                >
              </h4>
              <p class="section-completion-info">
                Non hai ancora compilato questa sezione
              </p>
            </div>
            <div id="62e9f2f2b9e688400" class="panel-collapse collapse in">
              <div class="panel-body toggle-content fusion-clearfix">
                Inserisci certificazioni, attestati e referenze

                <div
                  class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-nested-column-25 fusion-two-third fusion-column-first 2_3"
                  style="
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width: 66.66%;
                    width: calc(66.66% - ((4%) * 0.6666));
                    margin-right: 4%;
                  "
                >
                  <div
                    class="fusion-column-wrapper fusion-column-wrapper-25"
                    style="
                      padding: 0px 0px 0px 0px;
                      background-position: left top;
                      background-repeat: no-repeat;
                      -webkit-background-size: cover;
                      -moz-background-size: cover;
                      -o-background-size: cover;
                      background-size: cover;
                    "
                    data-bg-url=""
                  >
                    <p><strong>CERTIFICAZIONI</strong></p>
                  </div>
                </div>
                <div
                  class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-26 fusion-one-third fusion-column-last 1_3"
                  style="
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width: 33.33%;
                    width: calc(33.33% - ((4%) * 0.3333));
                  "
                >
                  <div
                    class="fusion-column-wrapper fusion-column-wrapper-26"
                    style="
                      padding: 0px 0px 0px 0px;
                      background-position: left top;
                      background-repeat: no-repeat;
                      -webkit-background-size: cover;
                      -moz-background-size: cover;
                      -o-background-size: cover;
                      background-size: cover;
                    "
                    data-bg-url=""
                  >
                    <div class="fusion-button-wrapper fusion-align-block">
                      <style type="text/css">
                        .fusion-button.button-28 {
                          border-radius: 0px;
                        }
                      </style>
                      <a
                        (click)="addCertification()"
                        class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                        target="_self"
                        ><span class="fusion-button-text">Aggiungi</span></a
                      >
                    </div>
                  </div>
                </div>

                <div *ngFor="let certification of certifications">
                  <div
                    class="fusion-separator fusion-full-width-sep sep-none"
                    style="
                      margin-left: auto;
                      margin-right: auto;
                      margin-top: 15px;
                    "
                  ></div>
                  <div
                    class="specialization-container"
                    style="display: flex; flex-wrap: wrap"
                  >
                    <div
                      class="fusion-builder-row fusion-builder-row-inner fusion-row"
                    >
                      <div
                        class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-11 fusion-one-half fusion-column-first 1_2"
                        style="
                          margin-top: 0px;
                          margin-bottom: 0px;
                          width: 50%;
                          width: calc(50% - ((4%) * 0.5));
                          margin-right: 4%;
                        "
                      >
                        <div
                          class="fusion-column-wrapper fusion-column-wrapper-11"
                          style="
                            padding: 0px 0px 0px 0px;
                            background-position: left top;
                            background-repeat: no-repeat;
                            -webkit-background-size: cover;
                            -moz-background-size: cover;
                            -o-background-size: cover;
                            background-size: cover;
                          "
                          data-bg-url=""
                        >
                          <ul
                            class="fusion-checklist fusion-checklist-15"
                            style="font-size: 16px; line-height: 27.2px"
                          >
                            <li class="fusion-li-item">
                              <div class="fusion-li-item-content">
                                CERTIFICAZIONE
                              </div>
                            </li>
                          </ul>
                          <div class="fusion-button-wrapper fusion-align-block">
                            <style type="text/css">
                              .fusion-button.button-17 .fusion-button-text,
                              .fusion-button.button-17 i {
                                color: #333333;
                              }

                              .fusion-button.button-17
                                .fusion-button-icon-divider {
                                border-color: #333333;
                              }

                              .fusion-button.button-17:hover
                                .fusion-button-text,
                              .fusion-button.button-17:hover i,
                              .fusion-button.button-17:focus
                                .fusion-button-text,
                              .fusion-button.button-17:focus i,
                              .fusion-button.button-17:active
                                .fusion-button-text,
                              .fusion-button.button-17:active {
                                color: #ffffff;
                              }

                              .fusion-button.button-17:hover
                                .fusion-button-icon-divider,
                              .fusion-button.button-17:hover
                                .fusion-button-icon-divider,
                              .fusion-button.button-17:active
                                .fusion-button-icon-divider {
                                border-color: #ffffff;
                              }

                              .fusion-button.button-17:hover,
                              .fusion-button.button-17:focus,
                              .fusion-button.button-17:active {
                                border-color: #ffffff;
                              }

                              .fusion-button.button-17 {
                                border-color: #333333;
                                border-radius: 0px;
                              }

                              .fusion-button.button-17 {
                                background: #ffffff;
                              }

                              .fusion-button.button-17:hover,
                              .button-17:focus,
                              .fusion-button.button-17:active {
                                background: #ffffff;
                              }
                            </style>
                            <input
                              placeholder="Inserisci certificazione"
                              class="manual-validation-valid"
                              class="ng-app-input"
                              type="text"
                              [(ngModel)]="certification.certification.name"
                              [ngModelOptions]="{ standalone: true }"
                              (ngModelChange)="setCertif(certification)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <style>
                      a {
                        color: #333333;
                      }
                      a:hover {
                        color: var(--ng-app-theme-yellow-color);
                      }
                    </style>
                    <div
                      class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-24 fusion-one-fourth fusion-column-last 1_4"
                      style="
                        margin-top: 0px;
                        margin-bottom: 0px;
                        width: 23%;
                        width: calc(23% - ((4% + 4%) * 0.25));
                      "
                    >
                      <div
                        class="fusion-column-wrapper fusion-column-wrapper-24"
                        style="
                          padding: 0px 0px 0px 0px;
                          background-position: left top;
                          background-repeat: no-repeat;
                          -webkit-background-size: cover;
                          -moz-background-size: cover;
                          -o-background-size: cover;
                          background-size: cover;
                        "
                        data-bg-url=""
                      >
                        <div
                          class="fusion-separator fusion-full-width-sep sep-none"
                          style="
                            margin-left: auto;
                            margin-right: auto;
                            margin-top: 40px;
                          "
                        ></div>
                        <div class="fusion-button-wrapper fusion-align-block">
                          <style type="text/css">
                            .fusion-button.button-28 {
                              border-radius: 0px;
                            }
                          </style>
                          <a
                            (click)="removeCertification(certification)"
                            class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                            target="_self"
                            ><span class="fusion-button-text">Rimuovi</span></a
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      class="fusion-separator fusion-full-width-sep sep-none"
                      style="
                        margin-left: auto;
                        margin-right: auto;
                        margin-top: 15px;
                      "
                    ></div>
                    <div
                      *ngIf="
                        certification.errorMessage !== null &&
                        certification.errorMessage != undefined
                      "
                      class="ng-alert"
                    >
                      {{ certification.errorMessage }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <style type="text/css">
        #accordion-2089-8 .fusifon-panel:hover,
        #accordion-2089-8 .fusion-panel.hover {
          background-color: #f9f9f9;
        }
        #accordion-2089-8 .fusion-panel {
          border-color: #d9d9d9;
          border-width: 1px;
          background-color: #ffffff;
        }
        .fusion-accordian #accordion-2089-8 .panel-title a .fa-fusion-box {
          color: #ffffff;
        }
        .fusion-accordian
          #accordion-2089-8
          .panel-title
          a
          .fa-fusion-box:before {
          font-size: 16px;
          width: 16px;
        }
        .fusion-accordian
          #accordion-2089-8.fusion-toggle-icon-right
          .fusion-toggle-heading {
          margin-right: 34px;
        }
        .fusion-accordian #accordion-2089-8 .panel-title a {
          font-size: 25px;
        }
        .fusion-accordian #accordion-2089-8 .fa-fusion-box {
          background-color: #6d6d6d;
          border-color: #6d6d6d;
        }
        .fusion-accordian #accordion-2089-8 .panel-title a:hover,
        #accordion-2089-8 .fusion-toggle-boxed-mode:hover .panel-title a {
          color: #ffa626;
        }
        .fusion-accordian #accordion-2089-8 .panel-title .active .fa-fusion-box,
        .fusion-accordian
          #accordion-2089-8
          .panel-title
          a:hover
          .fa-fusion-box {
          background-color: #ffa626 !important;
          border-color: #ffa626 !important;
        }
      </style> -->

      <div class="fusion-sep-clear"></div>
      <div
        *ngIf="!privateRegistry"
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>

      <!-- SPECIALIZZAZIONI  -->

      <div class="accordian fusion-accordian" *ngIf="!privateRegistry">
        <div
          class="panel-group fusion-toggle-icon-right"
          id="specializzazioni"
          role="tablist"
        >
          <div
            class="fusion-panel panel-default fusion-toggle-no-divider"
            role="tabpanel"
          >
            <div class="panel-heading">
              <h4
                class="panel-title toggle fusion-responsive-typography-calculated"
                data-fontsize="16"
                data-lineheight="22.08px"
                style="--fontSize: 16; line-height: 1.38; --minFontSize: 16"
              >
                <a
                  id="specializzazioni-link"
                  class="active"
                  aria-expanded="true"
                  aria-selected="true"
                  aria-controls="specializzazioni-panel"
                  role="tab"
                  data-toggle="collapse"
                  data-target="#specializzazioni-panel"
                  href="#specializzazioni-panel"
                  ><span class="fusion-toggle-icon-wrapper" aria-hidden="true"
                    ><i class="fa-fusion-box"></i></span
                  ><span class="fusion-toggle-heading"
                    >Specializzazioni</span
                  ></a
                >
                <p
                  class="section-completion-info"
                  *ngIf="!areSpecializationsValid()"
                >
                  Non hai ancora compilato questa sezione
                </p>
              </h4>
            </div>
            <div
              id="specializzazioni-panel"
              class="panel-collapse collapse in"
              style="height: auto"
            >
              <div class="panel-body toggle-content fusion-clearfix">
                <div
                  class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-nested-column-25 fusion-two-third fusion-column-first 2_3"
                  style="
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width: 66.66%;
                    width: calc(66.66% - ((4%) * 0.6666));
                    margin-right: 4%;
                  "
                >
                  <div
                    class="fusion-column-wrapper fusion-column-wrapper-25"
                    style="
                      padding: 0px 0px 0px 0px;
                      background-position: left top;
                      background-repeat: no-repeat;
                      -webkit-background-size: cover;
                      -moz-background-size: cover;
                      -o-background-size: cover;
                      background-size: cover;
                    "
                    data-bg-url=""
                  ></div>
                  <div
                    [ngStyle]="{
                      visibility:
                        specializationMessage === 'no_error'
                          ? 'hidden'
                          : 'visible'
                    }"
                    class="ng-alert"
                  >
                    {{ specializationMessage }}
                  </div>
                </div>
                <div
                  class="fusion-layout-column fusion_builder_column fusion_builder_column_1_3 fusion-builder-nested-column-26 fusion-one-third fusion-column-last 1_3"
                  style="
                    margin-top: 0px;
                    margin-bottom: 0px;
                    width: 33.33%;
                    width: calc(33.33% - ((4%) * 0.3333));
                  "
                >
                  <div
                    class="fusion-column-wrapper fusion-column-wrapper-26"
                    style="
                      padding: 0px 0px 0px 0px;
                      background-position: left top;
                      background-repeat: no-repeat;
                      -webkit-background-size: cover;
                      -moz-background-size: cover;
                      -o-background-size: cover;
                      background-size: cover;
                    "
                    data-bg-url=""
                  >
                    <div
                      id="specializations"
                      class="fusion-button-wrapper fusion-align-block"
                      *ngIf="addSpecializationButtonVisible"
                    >
                      <style type="text/css">
                        .fusion-button.button-28 {
                          border-radius: 0px;
                        }
                      </style>
                      <a
                        (click)="addSpecialization()"
                        class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                        target="_self"
                        ><span class="fusion-button-text">Aggiungi</span></a
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 15px;
                  "
                ></div>

                <!-- SPECIALIZATIONS FOR COMPANIES  -->
                <div *ngIf="!showhidedesigner">
                  <div *ngFor="let specialization of specializations">
                    <div
                      class="fusion-separator fusion-full-width-sep sep-none"
                      style="
                        margin-left: auto;
                        margin-right: auto;
                        margin-top: 15px;
                      "
                    ></div>
                    <div class="specialization-container">
                      <div
                        class="fusion-builder-row fusion-builder-row-inner fusion-row"
                      >
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-11 fusion-one-half fusion-column-first 1_2"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 50%;
                            width: calc(50% - ((4%) * 0.5));
                            margin-right: 4%;
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-11"
                            style="
                              padding: 0px 0px 0px 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              -webkit-background-size: cover;
                              -moz-background-size: cover;
                              -o-background-size: cover;
                              background-size: cover;
                            "
                            data-bg-url=""
                          >
                            <ul
                              class="fusion-checklist fusion-checklist-15"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <div class="fusion-li-item-content">
                                  Tipo Specializzazione*
                                </div>
                              </li>
                            </ul>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-17 .fusion-button-text,
                                .fusion-button.button-17 i {
                                  color: #333333;
                                }

                                .fusion-button.button-17
                                  .fusion-button-icon-divider {
                                  border-color: #333333;
                                }

                                .fusion-button.button-17:hover
                                  .fusion-button-text,
                                .fusion-button.button-17:hover i,
                                .fusion-button.button-17:focus
                                  .fusion-button-text,
                                .fusion-button.button-17:focus i,
                                .fusion-button.button-17:active
                                  .fusion-button-text,
                                .fusion-button.button-17:active {
                                  color: #ffffff;
                                }

                                .fusion-button.button-17:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-17:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-17:active
                                  .fusion-button-icon-divider {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-17:hover,
                                .fusion-button.button-17:focus,
                                .fusion-button.button-17:active {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-17 {
                                  border-color: #333333;
                                  border-radius: 0px;
                                }

                                .fusion-button.button-17 {
                                  background: #ffffff;
                                }

                                .fusion-button.button-17:hover,
                                .button-17:focus,
                                .fusion-button.button-17:active {
                                  background: #ffffff;
                                }
                              </style>
                              <select
                                [(ngModel)]="specialization.specialization.code"
                                [ngModelOptions]="{ standalone: true }"
                                class="manual-validation-valid"
                                (ngModelChange)="
                                  setSpecializationUM(specialization)
                                "
                              >
                                <option [ngValue]="null">
                                  Seleziona tipo specializzazione
                                </option>
                                <option
                                  [ngValue]="specializationType.code"
                                  *ngFor="
                                    let specializationType of specializationsCompanyList
                                  "
                                >
                                  {{ specializationType.description }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-12 fusion-one-half fusion-column-last 1_2"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 50%;
                            width: calc(50% - ((4%) * 0.5));
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-12"
                            style="
                              padding: 0px 0px 0px 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              -webkit-background-size: cover;
                              -moz-background-size: cover;
                              -o-background-size: cover;
                              background-size: cover;
                            "
                            data-bg-url=""
                            *ngIf="
                              specialization.um !== null &&
                              specialization.um !== undefined &&
                              !showhidedesigner
                            "
                          >
                            <ul
                              class="fusion-checklist fusion-checklist-16"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <div class="fusion-li-item-content">
                                  Prezzo*
                                </div>
                              </li>
                            </ul>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-18 .fusion-button-text,
                                .fusion-button.button-18 i {
                                  color: #333333;
                                }

                                .fusion-button.button-18
                                  .fusion-button-icon-divider {
                                  border-color: #333333;
                                }

                                .fusion-button.button-18:hover
                                  .fusion-button-text,
                                .fusion-button.button-18:hover i,
                                .fusion-button.button-18:focus
                                  .fusion-button-text,
                                .fusion-button.button-18:focus i,
                                .fusion-button.button-18:active
                                  .fusion-button-text,
                                .fusion-button.button-18:active {
                                  color: #ffffff;
                                }

                                .fusion-button.button-18:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-18:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-18:active
                                  .fusion-button-icon-divider {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-18:hover,
                                .fusion-button.button-18:focus,
                                .fusion-button.button-18:active {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-18 {
                                  border-color: #333333;
                                  border-radius: 0px;
                                }

                                .fusion-button.button-18 {
                                  background: #ffffff;
                                }

                                .fusion-button.button-18:hover,
                                .button-18:focus,
                                .fusion-button.button-18:active {
                                  background: #ffffff;
                                }
                              </style>
                              <div class="input-icon input-icon-right">
                                <input
                                  placeholder="Inserisci prezzo"
                                  type="text"
                                  [(ngModel)]="
                                    specialization.specialization.salesPrice
                                  "
                                  [ngModelOptions]="{ standalone: true }"
                                  (ngModelChange)="
                                    validateSalesPriceValue(specialization)
                                  "
                                />
                                <i>€</i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <style>
                        a {
                          color: #333333;
                        }
                        a:hover {
                          color: var(--ng-app-theme-yellow-color);
                        }
                      </style>
                      <div
                        style="
                          font-size: 15px;
                          line-height: 1.4;
                          font-weight: 600;
                          color: #333333;
                          margin-top: 5px;
                        "
                        *ngIf="
                          specialization.um === null ||
                          specialization.um === undefined
                        "
                      >
                        Se nella lista non è presente la lavorazione che
                        rappresenta la propria specializzazione, l'Utente ha la
                        possibilità di richiedere l'inserimento di una nuova
                        voce (allegando descrizione dettagliata) inviando
                        comunicazione a
                        <a href="mailto:support@skimmingbpe.com"
                          >support@skimmingbpe.com</a
                        >
                      </div>
                      <div
                        class="fusion-separator fusion-full-width-sep sep-none"
                        style="
                          margin-left: auto;
                          margin-right: auto;
                          margin-top: 15px;
                        "
                      ></div>
                      <div
                        class="fusion-builder-row fusion-builder-row-inner fusion-row"
                        *ngIf="
                          specialization.um !== null &&
                          specialization.um !== undefined
                        "
                      >
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-11 fusion-one-half fusion-column-first 1_2"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 50%;
                            width: calc(50% - ((4%) * 0.5));
                            margin-right: 4%;
                          "
                        >
                          <div
                            *ngIf="!showhidedesigner"
                            class="fusion-column-wrapper fusion-column-wrapper-11"
                            style="
                              padding: 0px 0px 0px 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              -webkit-background-size: cover;
                              -moz-background-size: cover;
                              -o-background-size: cover;
                              background-size: cover;
                            "
                            data-bg-url=""
                          >
                            <ul
                              class="fusion-checklist fusion-checklist-15"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <div
                                  class="fusion-li-item-content"
                                  style="text-transform: uppercase"
                                >
                                  Al {{ specialization.um }} Se Maggiore Di*
                                </div>
                              </li>
                            </ul>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-17 .fusion-button-text,
                                .fusion-button.button-17 i {
                                  color: #333333;
                                }

                                .fusion-button.button-17
                                  .fusion-button-icon-divider {
                                  border-color: #333333;
                                }

                                .fusion-button.button-17:hover
                                  .fusion-button-text,
                                .fusion-button.button-17:hover i,
                                .fusion-button.button-17:focus
                                  .fusion-button-text,
                                .fusion-button.button-17:focus i,
                                .fusion-button.button-17:active
                                  .fusion-button-text,
                                .fusion-button.button-17:active {
                                  color: #ffffff;
                                }

                                .fusion-button.button-17:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-17:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-17:active
                                  .fusion-button-icon-divider {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-17:hover,
                                .fusion-button.button-17:focus,
                                .fusion-button.button-17:active {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-17 {
                                  border-color: #333333;
                                  border-radius: 0px;
                                }

                                .fusion-button.button-17 {
                                  background: #ffffff;
                                }

                                .fusion-button.button-17:hover,
                                .button-17:focus,
                                .fusion-button.button-17:active {
                                  background: #ffffff;
                                }
                              </style>
                              <div class="input-icon input-icon-right">
                                <input
                                  placeholder="Inserisci {{
                                    specialization.um
                                  }}"
                                  type="text"
                                  [(ngModel)]="
                                    specialization.specialization.minAmount
                                  "
                                  [ngModelOptions]="{ standalone: true }"
                                  (ngModelChange)="
                                    resetSpecError(specialization)
                                  "
                                />
                                <i>{{ specialization.um }}</i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          *ngIf="!showhidedesigner"
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-23 fusion-one-fourth 1_4"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 25%;
                            width: calc(25% - ((4% + 4%) * 0.25));
                            margin-right: 4%;
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-23"
                            style="
                              padding: 0px 0px 0px 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              -webkit-background-size: cover;
                              -moz-background-size: cover;
                              -o-background-size: cover;
                              background-size: cover;
                            "
                            data-bg-url=""
                          >
                            <div
                              class="fusion-separator fusion-full-width-sep sep-none"
                              style="
                                margin-left: auto;
                                margin-right: auto;
                                margin-top: 40px;
                              "
                            ></div>
                            <ul
                              class="fusion-checklist fusion-checklist-16"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <input
                                  type="checkbox"
                                  id="chSpecActive"
                                  [ngModelOptions]="{ standalone: true }"
                                  [(ngModel)]="
                                    specialization.specialization
                                      .notificationEnabled
                                  "
                                  class="yellowBorderedCheckbox"
                                />
                                <label for="chSpecActive"
                                  ><span></span>Attiva notifiche</label
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-24 fusion-one-fourth fusion-column-last 1_4"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 23%;
                            width: calc(23% - ((4% + 4%) * 0.25));
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-24"
                            style="
                              padding: 0px 0px 0px 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              -webkit-background-size: cover;
                              -moz-background-size: cover;
                              -o-background-size: cover;
                              background-size: cover;
                            "
                            data-bg-url=""
                          >
                            <div
                              class="fusion-separator fusion-full-width-sep sep-none"
                              style="
                                margin-left: auto;
                                margin-right: auto;
                                margin-top: 40px;
                              "
                            ></div>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-28 {
                                  border-radius: 0px;
                                }
                              </style>
                              <a
                                (click)="removeSpecialization(specialization)"
                                class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                                target="_self"
                                ><span class="fusion-button-text"
                                  >Rimuovi</span
                                ></a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="fusion-separator fusion-full-width-sep sep-none"
                        *ngIf="
                          specialization.errorMessage !== null &&
                          specialization.errorMessage != undefined
                        "
                        style="
                          margin-left: auto;
                          margin-right: auto;
                          margin-top: 10px;
                        "
                      ></div>
                      <div
                        *ngIf="
                          specialization.errorMessage !== null &&
                          specialization.errorMessage != undefined
                        "
                        class="ng-alert"
                      >
                        {{ specialization.errorMessage }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SPECIALIZATION FOR PROFESSIONALS  -->
                <div *ngIf="showhidedesigner">
                  <div *ngFor="let specialization of specializations">
                    <div
                      class="fusion-separator fusion-full-width-sep sep-none"
                      style="
                        margin-left: auto;
                        margin-right: auto;
                        margin-top: 15px;
                      "
                    ></div>
                    <div class="specialization-container">
                      <div
                        class="fusion-builder-row fusion-builder-row-inner fusion-row"
                      >
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-11 fusion-one-half fusion-column-first 1_2"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 50%;
                            width: calc(50% - ((4%) * 0.5));
                            margin-right: 4%;
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-11"
                            style="
                              padding: 0px 0px 0px 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              -webkit-background-size: cover;
                              -moz-background-size: cover;
                              -o-background-size: cover;
                              background-size: cover;
                            "
                            data-bg-url=""
                          >
                            <ul
                              class="fusion-checklist fusion-checklist-15"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <div class="fusion-li-item-content">
                                  TIPO SPECIALIZZAZIONE*
                                </div>
                              </li>
                            </ul>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-17 .fusion-button-text,
                                .fusion-button.button-17 i {
                                  color: #333333;
                                }

                                .fusion-button.button-17
                                  .fusion-button-icon-divider {
                                  border-color: #333333;
                                }

                                .fusion-button.button-17:hover
                                  .fusion-button-text,
                                .fusion-button.button-17:hover i,
                                .fusion-button.button-17:focus
                                  .fusion-button-text,
                                .fusion-button.button-17:focus i,
                                .fusion-button.button-17:active
                                  .fusion-button-text,
                                .fusion-button.button-17:active {
                                  color: #ffffff;
                                }

                                .fusion-button.button-17:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-17:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-17:active
                                  .fusion-button-icon-divider {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-17:hover,
                                .fusion-button.button-17:focus,
                                .fusion-button.button-17:active {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-17 {
                                  border-color: #333333;
                                  border-radius: 0px;
                                }

                                .fusion-button.button-17 {
                                  background: #ffffff;
                                }

                                .fusion-button.button-17:hover,
                                .button-17:focus,
                                .fusion-button.button-17:active {
                                  background: #ffffff;
                                }
                              </style>
                              <select
                                [(ngModel)]="specialization.specialization.code"
                                [ngModelOptions]="{ standalone: true }"
                                class="manual-validation-valid"
                                (ngModelChange)="
                                  setSpecializationUM(specialization)
                                "
                              >
                                <option [ngValue]="null">
                                  Seleziona tipo specializzazione
                                </option>
                                <option
                                  [ngValue]="specializationType.code"
                                  *ngFor="
                                    let specializationType of specializationsProfessionalList
                                  "
                                >
                                  {{ specializationType.description }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-12 fusion-one-half fusion-column-last 1_2"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 50%;
                            width: calc(50% - ((4%) * 0.5));
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-12"
                            style="
                              padding: 0px 0px 0px 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              -webkit-background-size: cover;
                              -moz-background-size: cover;
                              -o-background-size: cover;
                              background-size: cover;
                            "
                            data-bg-url=""
                            *ngIf="
                              specialization.um !== null &&
                              specialization.um !== undefined &&
                              !showhidedesigner
                            "
                          >
                            <ul
                              class="fusion-checklist fusion-checklist-16"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <div class="fusion-li-item-content">
                                  PREZZO*
                                </div>
                              </li>
                            </ul>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-18 .fusion-button-text,
                                .fusion-button.button-18 i {
                                  color: #333333;
                                }

                                .fusion-button.button-18
                                  .fusion-button-icon-divider {
                                  border-color: #333333;
                                }

                                .fusion-button.button-18:hover
                                  .fusion-button-text,
                                .fusion-button.button-18:hover i,
                                .fusion-button.button-18:focus
                                  .fusion-button-text,
                                .fusion-button.button-18:focus i,
                                .fusion-button.button-18:active
                                  .fusion-button-text,
                                .fusion-button.button-18:active {
                                  color: #ffffff;
                                }

                                .fusion-button.button-18:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-18:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-18:active
                                  .fusion-button-icon-divider {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-18:hover,
                                .fusion-button.button-18:focus,
                                .fusion-button.button-18:active {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-18 {
                                  border-color: #333333;
                                  border-radius: 0px;
                                }

                                .fusion-button.button-18 {
                                  background: #ffffff;
                                }

                                .fusion-button.button-18:hover,
                                .button-18:focus,
                                .fusion-button.button-18:active {
                                  background: #ffffff;
                                }
                              </style>
                              <div class="input-icon input-icon-right">
                                <input
                                  placeholder="Inserisci prezzo"
                                  type="text"
                                  [(ngModel)]="
                                    specialization.specialization.salesPrice
                                  "
                                  [ngModelOptions]="{ standalone: true }"
                                  (ngModelChange)="
                                    validateSalesPriceValue(specialization)
                                  "
                                />
                                <i>€</i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <style>
                        a {
                          color: #333333;
                        }
                        a:hover {
                          color: var(--ng-app-theme-yellow-color);
                        }
                      </style>
                      <div
                        style="
                          font-size: 15px;
                          line-height: 1.4;
                          font-weight: 600;
                          color: #333333;
                          margin-top: 5px;
                        "
                        *ngIf="
                          specialization.um === null ||
                          specialization.um === undefined
                        "
                      >
                        Se nella lista non è presente la lavorazione che
                        rappresenta la propria specializzazione, l'Utente ha la
                        possibilità di richiedere l'inserimento di una nuova
                        voce (allegando descrizione dettagliata) inviando
                        comunicazione a
                        <a href="mailto:support@skimmingbpe.com"
                          >support@skimmingbpe.com</a
                        >
                      </div>
                      <div
                        class="fusion-separator fusion-full-width-sep sep-none"
                        style="
                          margin-left: auto;
                          margin-right: auto;
                          margin-top: 15px;
                        "
                      ></div>
                      <div
                        class="fusion-builder-row fusion-builder-row-inner fusion-row"
                        *ngIf="
                          specialization.um !== null &&
                          specialization.um !== undefined
                        "
                      >
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_2 fusion-builder-nested-column-11 fusion-one-half fusion-column-first 1_2"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 50%;
                            width: calc(50% - ((4%) * 0.5));
                            margin-right: 4%;
                          "
                        >
                          <div
                            *ngIf="!showhidedesigner"
                            class="fusion-column-wrapper fusion-column-wrapper-11"
                            style="
                              padding: 0px 0px 0px 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              -webkit-background-size: cover;
                              -moz-background-size: cover;
                              -o-background-size: cover;
                              background-size: cover;
                            "
                            data-bg-url=""
                          >
                            <ul
                              class="fusion-checklist fusion-checklist-15"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <div class="fusion-li-item-content">
                                  Al {{ specialization.um }} Se Maggiore Di*
                                </div>
                              </li>
                            </ul>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-17 .fusion-button-text,
                                .fusion-button.button-17 i {
                                  color: #333333;
                                }

                                .fusion-button.button-17
                                  .fusion-button-icon-divider {
                                  border-color: #333333;
                                }

                                .fusion-button.button-17:hover
                                  .fusion-button-text,
                                .fusion-button.button-17:hover i,
                                .fusion-button.button-17:focus
                                  .fusion-button-text,
                                .fusion-button.button-17:focus i,
                                .fusion-button.button-17:active
                                  .fusion-button-text,
                                .fusion-button.button-17:active {
                                  color: #ffffff;
                                }

                                .fusion-button.button-17:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-17:hover
                                  .fusion-button-icon-divider,
                                .fusion-button.button-17:active
                                  .fusion-button-icon-divider {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-17:hover,
                                .fusion-button.button-17:focus,
                                .fusion-button.button-17:active {
                                  border-color: #ffffff;
                                }

                                .fusion-button.button-17 {
                                  border-color: #333333;
                                  border-radius: 0px;
                                }

                                .fusion-button.button-17 {
                                  background: #ffffff;
                                }

                                .fusion-button.button-17:hover,
                                .button-17:focus,
                                .fusion-button.button-17:active {
                                  background: #ffffff;
                                }
                              </style>
                              <div class="input-icon input-icon-right">
                                <input
                                  placeholder="Inserisci {{
                                    specialization.um
                                  }}"
                                  type="text"
                                  [(ngModel)]="
                                    specialization.specialization.minAmount
                                  "
                                  [ngModelOptions]="{ standalone: true }"
                                  (ngModelChange)="
                                    resetSpecError(specialization)
                                  "
                                />
                                <i>{{ specialization.um }}</i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          *ngIf="!showhidedesigner"
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-23 fusion-one-fourth 1_4"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 25%;
                            width: calc(25% - ((4% + 4%) * 0.25));
                            margin-right: 4%;
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-23"
                            style="
                              padding: 0px 0px 0px 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              -webkit-background-size: cover;
                              -moz-background-size: cover;
                              -o-background-size: cover;
                              background-size: cover;
                            "
                            data-bg-url=""
                          >
                            <div
                              class="fusion-separator fusion-full-width-sep sep-none"
                              style="
                                margin-left: auto;
                                margin-right: auto;
                                margin-top: 40px;
                              "
                            ></div>
                            <ul
                              class="fusion-checklist fusion-checklist-16"
                              style="font-size: 16px; line-height: 27.2px"
                            >
                              <li class="fusion-li-item">
                                <input
                                  type="checkbox"
                                  id="chSpecActive"
                                  [ngModelOptions]="{ standalone: true }"
                                  [(ngModel)]="
                                    specialization.specialization
                                      .notificationEnabled
                                  "
                                  class="yellowBorderedCheckbox"
                                />
                                <label for="chSpecActive"
                                  ><span></span>Attiva notifiche</label
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="fusion-layout-column fusion_builder_column fusion_builder_column_1_4 fusion-builder-nested-column-24 fusion-one-fourth fusion-column-last 1_4"
                          style="
                            margin-top: 0px;
                            margin-bottom: 0px;
                            width: 23%;
                            width: calc(23% - ((4% + 4%) * 0.25));
                          "
                        >
                          <div
                            class="fusion-column-wrapper fusion-column-wrapper-24"
                            style="
                              padding: 0px 0px 0px 0px;
                              background-position: left top;
                              background-repeat: no-repeat;
                              -webkit-background-size: cover;
                              -moz-background-size: cover;
                              -o-background-size: cover;
                              background-size: cover;
                            "
                            data-bg-url=""
                          >
                            <div
                              class="fusion-separator fusion-full-width-sep sep-none"
                              style="
                                margin-left: auto;
                                margin-right: auto;
                                margin-top: 40px;
                              "
                            ></div>
                            <div
                              class="fusion-button-wrapper fusion-align-block"
                            >
                              <style type="text/css">
                                .fusion-button.button-28 {
                                  border-radius: 0px;
                                }
                              </style>
                              <a
                                (click)="removeSpecialization(specialization)"
                                class="fusion-button button-flat fusion-button-default-size button-default button-28 fusion-button-span-yes fusion-button-default-type"
                                target="_self"
                                ><span class="fusion-button-text"
                                  >Rimuovi</span
                                ></a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="fusion-separator fusion-full-width-sep sep-none"
                        *ngIf="
                          specialization.errorMessage !== null &&
                          specialization.errorMessage != undefined
                        "
                        style="
                          margin-left: auto;
                          margin-right: auto;
                          margin-top: 10px;
                        "
                      ></div>
                      <div
                        *ngIf="
                          specialization.errorMessage !== null &&
                          specialization.errorMessage != undefined
                        "
                        class="ng-alert"
                      >
                        {{ specialization.errorMessage }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- SAVE BUTTON  -->
                <div class="fusion-sep-clear"></div>
                <div
                  class="fusion-separator fusion-full-width-sep sep-none"
                  style="
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 20px;
                  "
                ></div>

                <!-- <div
                  [ngStyle]="{
                    visibility: error === 'no_error' ? 'hidden' : 'visible'
                  }"
                  class="ng-{{ errorMessageClass }}"
                >
                  {{ error }}
                </div> -->
                <div class="ng-spinner">
                  <img
                    *ngIf="loading"
                    src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
                  />
                </div>
                <div class="fusion-button-wrapper fusion-alignright">
                  <style type="text/css">
                    .fusion-button.button-35 {
                      border-radius: 0px;
                    }
                  </style>
                  <a
                    (click)="closeAccordion('specializzazioni-link')"
                    appInvalidControlScroll
                    class="fusion-button button-flat button-large button-default button-35 fusion-button-default-span fusion-button-default-type"
                    target="_self"
                    ><span class="fusion-button-text">Conferma</span></a
                  >
                </div>

                <!-- SAVE BUTTON  -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fusion-clearfix"></div>

      <!-- MANAGE NOTIFICATIONS  -->

      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>
      <div
        *ngIf="!privateRegistry"
        class="fusion-layout-column fusion_builder_column fusion_builder_column_2_3 fusion-builder-nested-column-25 fusion-two-third fusion-column-first 2_3"
        style="
          margin-top: 0px;
          margin-bottom: 0px;
          width: 66.66%;
          width: calc(66.66% - ((4%) * 0.6666));
          margin-right: 4%;
        "
      >
        <div
          class="fusion-column-wrapper fusion-column-wrapper-25"
          style="
            padding: 0px 0px 0px 0px;
            background-position: left top;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          "
          data-bg-url=""
        >
          <p><strong>NOTIFICHE</strong></p>
        </div>
      </div>
      <div class="fusion-sep-clear"></div>
      <!-- <div class="fusion-separator fusion-full-width-sep sep-none"
		style="margin-left: auto;margin-right: auto;margin-top:20PX;"></div> -->
      <div
        class="fusion-button-wrapper fusion-align-block"
        *ngIf="!privateRegistry"
      >
        <style type="text/css">
          .fusion-button.button-1 .fusion-button-text,
          .fusion-button.button-1 i {
            color: #a5a5a5;
          }

          .fusion-button.button-1 .fusion-button-icon-divider {
            border-color: #a5a5a5;
          }

          .fusion-button.button-1:hover .fusion-button-text,
          .fusion-button.button-1:hover i,
          .fusion-button.button-1:focus .fusion-button-text,
          .fusion-button.button-1:focus i,
          .fusion-button.button-1:active .fusion-button-text,
          .fusion-button.button-1:active {
            color: #ffffff;
          }

          .fusion-button.button-1:hover .fusion-button-icon-divider,
          .fusion-button.button-1:hover .fusion-button-icon-divider,
          .fusion-button.button-1:active .fusion-button-icon-divider {
            border-color: #ffffff;
          }

          .fusion-button.button-1:hover,
          .fusion-button.button-1:focus,
          .fusion-button.button-1:active {
            border-color: #ffffff;
          }

          .fusion-button.button-1 {
            border-color: #333333;
            border-radius: 0px;
          }

          .fusion-button.button-1 {
            background: #ffffff;
          }

          .fusion-button.button-1:hover,
          .button-1:focus,
          .fusion-button.button-1:active {
            background: #ffffff;
          }
        </style>
        <ul
          class="fusion-checklist fusion-checklist-16"
          style="font-size: 16px; line-height: 27.2px"
        >
          <li class="fusion-li-item">
            <input
              type="checkbox"
              id="chNotificationActive"
              formControlName="customerNotificationEnabled"
              class="yellowBorderedCheckbox"
            />
            <label *ngIf="showhidedesigner" for="chNotificationActive"
              ><span></span>Permetti al sistema di notificarti i migliori
              offerenti per ogni gara
            </label>
            <label *ngIf="!showhidedesigner" for="chNotificationActive"
              ><span></span>Permetti al sistema di notificarti le gare di tuo
              interesse
            </label>
          </li>
        </ul>
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 40px"
      ></div>

      <!-- SAVE BUTTON  -->
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 10px"
      ></div>
      <div
        [ngStyle]="{ visibility: error === 'no_error' ? 'hidden' : 'visible' }"
        class="ng-{{ errorMessageClass }}"
      >
        {{ error }}
      </div>
      <div class="ng-spinner">
        <img
          *ngIf="loading"
          src="/wp-content/themes/Avada-Child-Theme/images/spinner_yellow.svg"
        />
      </div>
      <div class="fusion-sep-clear"></div>
      <div
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 20px"
      ></div>
      <div class="fusion-button-wrapper fusion-alignright">
        <style type="text/css">
          .fusion-button.button-35 {
            border-radius: 0px;
          }
        </style>
        <a
          (click)="profileSubmitHandler()"
          appInvalidControlScroll
          class="fusion-button button-flat button-xlarge button-default button-35 fusion-button-default-span fusion-button-default-type"
          target="_self"
          ><span class="fusion-button-icon-divider button-icon-divider-left"
            ><i class="fa-cloud-upload-alt fas"></i></span
          ><span class="fusion-button-text fusion-button-text-left"
            >SALVA PROFILO</span
          ></a
        >
      </div>
    </div>
  </div>
  <ul class="fusion-checklist fusion-checklist-16" style="visibility: hidden">
    <li class="fusion-li-item">
      <input
        #checkDesigner
        type="checkbox"
        id="chDesigner"
        formControlName="designer"
        class="yellowBorderedCheckbox"
        [(ngModel)]="showhidedesigner"
        (click)="deleteSpecializations(); switchUserType()"
      />
      <label for="chDesigner"><span></span>Seleziona se sei progettista</label>
    </li>
  </ul>
</form>
